export const common = {
  // Common
  'common.edit': 'Editar',
  'common.delete': 'Eliminar',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.loading': 'Cargando...',
  'common.error': 'Error',
  'common.success': 'Éxito',
  'common.confirm': 'Confirmar',
  'common.back': 'Volver',
  'common.next': 'Siguiente',
  'common.previous': 'Anterior',
  'common.submit': 'Enviar',
  'common.search': 'Buscar',
  'common.filter': 'Filtrar',
  'common.sort': 'Ordenar',
  'common.view': 'Ver',
  'common.download': 'Descargar',
  'common.upload': 'Subir',
  'common.select': 'Seleccionar',
  'common.selectAll': 'Seleccionar todo',
  'common.deselectAll': 'Deseleccionar todo',
  'common.clear': 'Limpiar',
  'common.reset': 'Restablecer',
  'common.apply': 'Aplicar',
  'common.ok': 'OK',
  'common.yes': 'Sí',
  'common.no': 'No',

  // Navigation
  'nav.home': 'INICIO',
  'nav.howItWorks': 'CÓMO FUNCIONA',
  'nav.forParents': 'PARA PADRES',
  'nav.pricing': 'PRECIOS',
  'nav.login': 'Iniciar Sesión',
  'nav.register': 'Registrarse',
  'nav.menu': 'Menú',

  // Hero
  'hero.badge': 'Aprendizaje Inteligente',
  'hero.title1': 'Aprende Resolviendo',
  'hero.title2': 'Tus Tareas con',
  'hero.title3': 'Ayuda Inteligente',
  'hero.description': 'Nuestra IA guía a los niños paso a paso sin dar respuestas directas. Aprenden a pensar por sí mismos mientras reciben el apoyo que necesitan.',
  'hero.startFree': 'Comenzar Gratis',
  'hero.meetTutors': 'Conoce a los Tutores',
  'hero.viewDemo': 'Ver Demo',

  // Demo Page
  'demo.badge': 'Demo Interactiva',
  'demo.title': 'Vive la Magia',
  'demo.subtitle': 'Mira cómo nuestra IA guía al estudiante paso a paso',
  'demo.assistant': 'Tutor IA',
  'demo.helpingWith': 'Ayudando con Matemáticas',
  'demo.startDemo': 'Iniciar Demo',
  'demo.pause': 'Pausar',
  'demo.readyTitle': '¿Listo para Empezar?',
  'demo.readySubtitle': 'Mira una simulación interactiva de cómo nuestra IA ayuda sin dar respuestas.',
  'demo.startNow': 'Comenzar Ahora',
  'demo.provenMethodology': 'Metodología Comprobada',
  'demo.noDirectAnswers': 'Sin Respuestas Directas',
  'demo.messages': 'Mensajes',
  'demo.progress': 'Progreso',
  'demo.badgeUnlocked': '¡Insignia Desbloqueada!',
  'demo.studentEarned': 'El estudiante ganó "Maestro de la División"',
  'demo.watchAgain': 'Ver de Nuevo',
  'demo.startFree': 'Comenzar Prueba Gratuita',
  'demo.features.guided.title': 'Aprendizaje Guiado',
  'demo.features.guided.description': 'Guía conversacional que se adapta al estudiante.',
  'demo.features.realLearning.title': 'Aprendizaje Real',
  'demo.features.realLearning.description': 'Los estudiantes resuelven los problemas por sí mismos.',
  'demo.features.achievements.title': 'Logros',
  'demo.features.achievements.description': 'Elementos gamificados que los mantienen motivados.',
  'demo.cta.title': '¿Listo para Probarlo?',
  'demo.cta.subtitle': 'Comienza tu prueba gratuita hoy.',
  'demo.cta.startTrial': 'Comenzar Prueba Gratuita',
  'demo.cta.viewPlans': 'Ver Planes',

  // Features
  'features.title': '¿Cómo Funciona TutorAI Kids?',
  'features.subtitle': 'Una metodología diseñada para el aprendizaje real',
  'features.guided.title': 'Conversación Guiada',
  'features.guided.desc': 'La IA interactúa con preguntas que estimulan el pensamiento crítico y la resolución de problemas.',
  'features.noAnswers.title': 'Sin Respuestas Directas',
  'features.noAnswers.desc': 'Nunca damos la respuesta completa. Guiamos con pistas y preguntas para que lleguen a la solución por sí mismos.',
  'features.dashboard.title': 'Panel para Padres',
  'features.dashboard.desc': 'Reportes detallados sobre el progreso, áreas de mejora y tiempo dedicado al estudio de tus hijos.',
  'features.motivation.title': 'Motivación Constante',
  'features.motivation.desc': 'Sistema de logros, insignias y reconocimientos que mantienen a los niños motivados y comprometidos.',
  'features.viewDemo': 'Ver Demo Interactiva',

  // Testimonials
  'testimonials.title': 'Lo Que Dicen los Padres',
  'testimonials.subtitle': 'Familias satisfechas con el progreso de sus hijos',
  'testimonials.parent1.name': 'Jennifer Smith',
  'testimonials.parent1.username': '@jennifers',
  'testimonials.parent1.text': 'Mi hijo de 10 años ha mejorado increíblemente en matemáticas. Ahora resuelve problemas que antes parecían imposibles. ¡La IA es muy paciente!',
  'testimonials.parent2.name': 'Jorge Ramírez',
  'testimonials.parent2.username': '@jramirez',
  'testimonials.parent2.text': 'Como padre ocupado, el dashboard me permite ver exactamente en qué está trabajando mi hija y dónde necesita más apoyo. Es fantástico.',
  'testimonials.parent3.name': 'Sarah Johnson',
  'testimonials.parent3.username': '@sarahj',
  'testimonials.parent3.text': 'Lo mejor es que no le da las respuestas. Mi hijo realmente aprende a pensar por sí mismo.',
  'testimonials.parent4.name': 'Carlos Sánchez',
  'testimonials.parent4.username': '@carloss',
  'testimonials.parent4.text': 'Mis gemelos de 8 años están obsesionados con ganar insignias. Han convertido las tareas en un juego divertido. Los reportes semanales son muy detallados y útiles.',
  'testimonials.parent5.name': 'Emily Davis',
  'testimonials.parent5.username': '@emilyd',
  'testimonials.parent5.text': 'La plataforma es intuitiva y segura. Me encanta poder revisar las conversaciones y ver cómo la IA guía a mi hija sin darle las respuestas.',
  'testimonials.parent6.name': 'Roberto Flores',
  'testimonials.parent6.username': '@rflores',
  'testimonials.parent6.text': 'Excelente inversión en la educación de mis hijos. Han ganado confianza y autonomía en sus estudios.',

  // Methodology
  'methodology.label': 'NUESTRA METODOLOGÍA',
  'methodology.title': 'Aprendizaje Guiado,',
  'methodology.titleItalic': 'Resultados Reales',
  'methodology.p1': 'En TutorAI Kids creemos que el verdadero aprendizaje ocurre cuando los niños descubren las soluciones por sí mismos. Nuestra inteligencia artificial está diseñada para hacer las preguntas correctas en el momento correcto.',
  'methodology.p2': 'En lugar de proporcionar respuestas directas, la IA analiza el problema, identifica dónde está atascado el estudiante y ofrece pistas estratégicas que lo guían hacia la comprensión profunda del concepto.',
  'methodology.p3': 'Los padres reciben reportes detallados que muestran no solo qué tarea completó su hijo, sino cómo pensó, qué estrategias usó y dónde necesita refuerzo adicional.',

  // Pricing
  'pricing.title': 'Planes para Cada Familia',
  'pricing.subtitle': 'Elige el plan que mejor se adapte a tus necesidades',
  'pricing.basic.title': 'Básico',
  'pricing.basic.price': '$29.99',
  'pricing.basic.period': '/mes',
  'pricing.basic.feature1': '1 estudiante',
  'pricing.basic.liveSessions': 'Hasta 120 min/mes (4 sesiones)',
  'pricing.basic.talkWith': '¡Habla con Miss Ann!',
  'pricing.basic.feature2': 'Tutoría IA e imágenes',
  'pricing.basic.feature3': 'Gestión de tareas',
  'pricing.basic.feature4': 'Juegos educativos',
  'pricing.basic.feature5': 'Reportes semanales',
  'pricing.basic.feature6': 'Soporte por email',
  'pricing.basic.button': 'Comenzar Ahora',
  'pricing.family.title': 'Familiar',
  'pricing.family.badge': 'MÁS POPULAR',
  'pricing.family.price': '$59.99',
  'pricing.family.period': '/mes',
  'pricing.family.liveSessions': 'Hasta 90 min/semana por niño (3 sesiones)',
  'pricing.family.talkWith': '¡Habla con Miss Ann!',
  'pricing.family.feature1': 'Hasta 3 estudiantes',
  'pricing.family.feature2': 'Tutoría IA ilimitada (con imágenes)',
  'pricing.family.feature3': 'Gestión de Tareas',
  'pricing.family.feature4': 'Todos los juegos educativos',
  'pricing.family.feature5': 'Reportes detallados por materia',
  'pricing.family.feature6': 'Plan de Estudio Inteligente con IA',
  'pricing.family.feature7': 'Exámenes de Práctica',
  'pricing.family.feature8': 'Conexión Familiar',
  'pricing.family.feature9': 'Soporte Prioritario',
  'pricing.family.button': 'Comenzar Ahora',
  'pricing.premium.title': 'Premium',
  'pricing.premium.price': 'Precio Personalizado',
  'pricing.premium.period': '',
  'pricing.premium.feature1': 'Estudiantes ilimitados',
  'pricing.premium.feature2': 'Todo en Plan Familiar',
  'pricing.premium.feature3': 'Notificaciones por email',
  'pricing.premium.feature4': 'Reportes personalizados',
  'pricing.premium.feature5': 'Soporte prioritario 24/7',
  'pricing.premium.feature6': 'Sesiones de tutoría personalizadas',
  'pricing.premium.button': 'Contactar Ventas',
  'pricing.faq.title': 'Preguntas Frecuentes',
  'pricing.faq.q1': '¿Puedo cambiar mi plan en cualquier momento?',
  'pricing.faq.a1': 'Sí, puedes actualizar o cambiar tu plan en cualquier momento desde tu perfil.',
  'pricing.faq.q2': '¿Qué métodos de pago aceptan?',
  'pricing.faq.a2': 'Aceptamos todas las principales tarjetas de crédito y débito a través de Stripe.',
  'pricing.faq.q3': '¿Puedo cancelar mi suscripción?',
  'pricing.faq.a3': 'Sí, puedes cancelar tu suscripción en cualquier momento. Continuarás teniendo acceso hasta el final de tu período de facturación.',
  'pricing.faq.q4': '¿Hay una prueba gratuita?',
  'pricing.faq.a4': 'Sí, ofrecemos una prueba gratuita de 3 días para todos los nuevos usuarios. No se requiere tarjeta de crédito.',

  // CTA
  'cta.title': 'Comienza a Mejorar el Aprendizaje de Tus Hijos Hoy',
  'cta.subtitle': 'Prueba gratuita de 3 días. No se requiere tarjeta de crédito.',
  'cta.button': 'Crear Cuenta Gratuita',

  // Footer
  'footer.description': 'Transformando la educación con inteligencia artificial que guía sin dar respuestas.',
  'footer.newsletter': 'BOLETÍN',
  'footer.emailPlaceholder': 'Tu email',
  'footer.privacyText': 'Al suscribirte aceptas nuestra',
  'footer.privacyLink': 'política de privacidad',
  'footer.privacyPolicy': 'Política de Privacidad',
  'footer.termsOfService': 'Términos de Servicio',
  'footer.accessibility': 'Accesibilidad',
  'footer.resources': 'RECURSOS',
  'footer.blog': 'Blog',
  'footer.guides': 'Guías para Padres',
  'footer.faq': 'FAQ',
  'footer.followUs': 'SÍGUENOS',
  'footer.copyright': 'Todos los derechos reservados.',
  'privacy.footerCopyright': 'Todos los derechos reservados. TutorAI Kids es una marca registrada de Neo AI Estudio.',

  // Login Page
  'login.title': 'Bienvenido de Nuevo',
  'login.subtitle': 'Inicia sesión para ver el progreso de tus hijos',
  'login.email': 'Correo Electrónico',
  'login.password': 'Contraseña',
  'login.rememberMe': 'Recordarme',
  'login.forgotPassword': '¿Olvidaste tu contraseña?',
  'login.signInButton': 'Iniciar Sesión',
  'login.signingIn': 'Iniciando sesión...',
  'login.noAccount': '¿No tienes una cuenta?',
  'login.signUpLink': 'Regístrate gratis',
  'login.backToHome': 'Volver al inicio',

  // Register Page
  'register.title': 'Crea Tu Cuenta',
  'register.subtitle': 'Comienza a mejorar el aprendizaje de tus hijos',
  'register.fullName': 'Nombre Completo',
  'register.email': 'Correo Electrónico',
  'register.phone': 'Teléfono (Opcional)',
  'register.password': 'Contraseña',
  'register.confirmPassword': 'Confirmar Contraseña',
  'register.createButton': 'Crear Cuenta',
  'register.creating': 'Creando cuenta...',
  'register.haveAccount': '¿Ya tienes una cuenta?',
  'register.signInLink': 'Inicia sesión',
  'register.backToHome': 'Volver al inicio',
  'register.passwordMismatch': 'Las contraseñas no coinciden',
  'register.passwordTooShort': 'La contraseña debe tener al menos 6 caracteres',
  'register.acceptTermsPrefix': 'He leído y acepto los',
  'register.termsOfServiceLink': 'Términos de Servicio',
  'register.acceptTermsAnd': 'y la',
  'register.privacyPolicyLink': 'Política de Privacidad',
  'register.mustAcceptTerms': 'Debes aceptar los Términos de Servicio y la Política de Privacidad para continuar',
  'register.passwordHint': 'Mínimo 8 caracteres, incluyendo letras y números',
  'confirmAccount.confirming': 'Confirmando tu cuenta...',
  'confirmAccount.successTitle': '¡Cuenta confirmada!',
  'confirmAccount.successMessage': 'Tu cuenta ya está lista. Redirigiendo a tu panel...',
  'confirmAccount.errorTitle': 'No pudimos confirmar tu cuenta',
  'confirmAccount.errorMessage': 'El enlace puede haber expirado o ya haber sido usado. Intenta iniciar sesión o regístrate de nuevo.',
  'confirmAccount.goToLogin': 'Ir a iniciar sesión',
  'forgotPassword.title': 'Recuperar Contraseña',
  'forgotPassword.subtitle': 'Te enviaremos un enlace para restablecerla',
  'forgotPassword.email': 'Correo Electrónico',
  'forgotPassword.sendButton': 'Enviar Enlace',
  'forgotPassword.sending': 'Enviando...',
  'forgotPassword.successTitle': '📧 Revisa tu correo',
  'forgotPassword.successMessage': 'Si existe una cuenta con {{email}}, te enviamos un enlace para restablecer tu contraseña.',
  'forgotPassword.backToLogin': 'Volver a iniciar sesión',
  'resetPassword.title': 'Nueva Contraseña',
  'resetPassword.subtitle': 'Elige una nueva contraseña para tu cuenta',
  'resetPassword.newPassword': 'Nueva Contraseña',
  'resetPassword.confirmPassword': 'Confirmar Contraseña',
  'resetPassword.updateButton': 'Actualizar Contraseña',
  'resetPassword.updating': 'Actualizando...',
  'resetPassword.successTitle': '✅ ¡Contraseña actualizada!',
  'resetPassword.successMessage': 'Ya puedes iniciar sesión con tu nueva contraseña.',
  'resetPassword.invalidLink': 'Este enlace no es válido o ya expiró. Solicita uno nuevo.',
  'curiousAdventures.sectionTitle': '🎬 Aventuras Curiosas',
  'curiousAdventures.sectionSubtitle': 'Capítulos cortos y divertidos para aprender algo nuevo',
  'curiousAdventures.viewAll': 'Ver todos',
  'curiousAdventures.chapter': 'Capítulo {{number}}',
  'curiousAdventures.comingSoon': 'Próximamente',
  'curiousAdventures.availableOn': 'Disponible el {{date}}',
  'curiousAdventures.notReadyYet': '¡Este capítulo estará listo muy pronto! Vuelve a intentarlo en un ratito.',
  'curiousAdventures.pageTitle': 'Aventuras Curiosas',
  'curiousAdventures.pageSubtitle': 'Todos los capítulos, uno nuevo cada pocos días',
  'curiousAdventures.backToDashboard': 'Volver al Dashboard',
  'curiousAdventures.close': 'Cerrar',
  'register.successTitle': '¡Cuenta creada exitosamente!',
  'register.successEmailTitle': '📧 Confirma tu correo',
  'register.successEmailBody': 'Te hemos enviado un correo a {{email}} con un enlace para confirmar tu cuenta.',
  'register.successCheckSpam': '⚠️ Revisa también tu carpeta de spam si no lo ves',
  'register.successRedirecting': 'Redirigiendo al inicio de sesión...',

  // Dashboard - CLAVES EXACTAS QUE USA EL CÓDIGO
  'dashboard.title': 'Panel de Control',
  'dashboard.subtitle': 'Gestiona el aprendizaje de tus hijos',
  'dashboard.welcome': 'Bienvenido',
  'dashboard.students': 'Estudiantes',
  'dashboard.myStudents': 'Mis Estudiantes',
  'dashboard.addStudent': 'Agregar Estudiante',
  'dashboard.addFirstStudent': 'Agregar Primer Estudiante',
  'dashboard.noStudents': 'No hay estudiantes registrados',
  'dashboard.totalSessions': 'Sesiones Totales',
  'dashboard.thisWeek': 'esta semana',
  'dashboard.achievementsEarned': 'Logros Obtenidos',
  'dashboard.sessions': 'Sesiones',
  'dashboard.achievements': 'Logros',
  'dashboard.streak': 'Racha',
  'dashboard.viewDetails': 'Ver Detalles',
  'dashboard.startSession': 'Iniciar Sesión',
  'dashboard.homework': 'Tareas',
  'dashboard.logout': 'Cerrar Sesión',
  'dashboard.deleteConfirm': '¿Estás seguro de que quieres eliminar este estudiante?',
  'dashboard.addStudentModal.title': 'Agregar Nuevo Estudiante',
  'dashboard.addStudentModal.studentName': 'Nombre del Estudiante',
  'dashboard.addStudentModal.age': 'Edad',
  'dashboard.addStudentModal.grade': 'Grado',
  'dashboard.addStudentModal.selectGrade': 'Selecciona un grado',
  'dashboard.addStudentModal.cancel': 'Cancelar',
  'dashboard.addStudentModal.add': 'Agregar',
  'dashboard.addStudentModal.addButton': 'Agregar Estudiante',
  'dashboard.addStudentModal.namePlaceholder': 'Ej: María García',
  'dashboard.addStudentModal.agePlaceholder': 'Ej: 10',
  'dashboard.addStudentModal.mustBeLoggedIn': 'Debes iniciar sesión para agregar un estudiante',
  'dashboard.addStudentModal.errorAdding': 'Error al agregar estudiante',
  'dashboard.addStudentModal.saving': 'Guardando...',
  'dashboard.addStudentModal.gradeOptions.preschool': 'Preescolar',
  'dashboard.addStudentModal.gradeOptions.grade1': '1er Grado',
  'dashboard.addStudentModal.gradeOptions.grade2': '2do Grado',
  'dashboard.addStudentModal.gradeOptions.grade3': '3er Grado',
  'dashboard.addStudentModal.gradeOptions.grade4': '4to Grado',
  'dashboard.addStudentModal.gradeOptions.grade5': '5to Grado',
  'dashboard.addStudentModal.gradeOptions.grade6': '6to Grado',
  'dashboard.addStudentModal.gradeOptions.grade7': '7mo Grado',
  'dashboard.addStudentModal.gradeOptions.grade8': '8vo Grado',
  'dashboard.addStudentModal.gradeOptions.grade9': '9no Grado',
  'dashboard.addStudentModal.gradeOptions.grade10': '10mo Grado',
  'dashboard.addStudentModal.gradeOptions.grade11': '11vo Grado',
  'dashboard.addStudentModal.gradeOptions.grade12': '12vo Grado',

  // Student - CLAVES EXACTAS
  'student.profile': 'Perfil del Estudiante',
  'student.years': 'años',
  'student.startSession': 'Iniciar Sesión',
  'student.progressBySubject': 'Progreso por Materia',
  'student.recentActivity': 'Actividad Reciente',
  'student.noActivity': 'No hay actividad reciente',

  // Tutoring - CLAVES EXACTAS
  'tutoring.title': 'Tutoría con IA',
  'tutoring.subtitle': 'Asistente educativo inteligente',
  'tutoring.welcomeMessage': '¡Hola {{name}}! 👋 Soy tu Tutor IA. Estoy aquí para ayudarte a aprender y divertirnos juntos. ¿Qué vamos a estudiar hoy?',

  // Homework - CLAVES EXACTAS
  'homework.title': 'Tareas',
  'homework.management': 'Gestión de Tareas',
  'homework.manageDescription': 'Rastrea y organiza las asignaciones de tus hijos',
  'homework.newHomework': 'Nueva Tarea',
  'homework.back': 'Volver',
  'homework.totalHomework': 'Total de Tareas',
  'homework.completed': 'Completadas',
  'homework.pending': 'Pendientes',
  'homework.inProgress': 'En Progreso',
  'homework.homework': 'Tarea',
  'homework.student': 'Estudiante',
  'homework.status': 'Estado',
  'homework.actions': 'Acciones',
  'homework.noHomework': 'No hay tareas aún',
  'homework.noHomeworkForStudent': 'Aún no hay tareas para {{name}}',
  'homework.allStudents': 'Todos los estudiantes',
  'homework.addFirstHomework': 'Agrega la primera asignación para comenzar a rastrear el progreso',
  'homework.homeworkTitle': 'Título',
  'homework.titlePlaceholder': 'ej. Matemáticas págs. 42-43',
  'homework.selectStudent': 'Seleccionar Estudiante',
  'homework.cancel': 'Cancelar',
  'homework.add': 'Agregar Tarea',
  'homework.unassigned': 'Sin asignar',
  'homework.loading': 'Cargando tareas...',
  'homework.confirmDelete': '¿Estás seguro de que quieres eliminar esta tarea?',
  'homework.completeAllFields': 'Por favor completa todos los campos',
  'homework.mustLogin': 'Debes iniciar sesión',
  'homework.errorAdding': 'Error al agregar la tarea',
  'homework.errorDeleting': 'Error al eliminar la tarea',

  // Games - CLAVES EXACTAS
  'games.title': 'Juegos Educativos',
  'games.whyGames': '¿Por Qué Juegos Educativos?',
  'games.whyGamesDescription': 'Nuestros juegos están diseñados para hacer que aprender sea divertido y efectivo, ayudándote a dominar nuevas habilidades mientras juegas.',
  'games.new': 'NUEVO',
  'games.playNow': 'Jugar Ahora',
  'games.language': 'Lenguaje',
  'games.history': 'Historia',
  'games.geography': 'Geografía',
  'games.biology': 'Biología',
  'games.math': 'Matemáticas',
  'games.preschool': 'Preescolar',
  'games.prekTo1st': 'Pre-K a 1er Grado',
  'games.grades3to8': 'Grados 3-8',
  'games.grades3to6': 'Grados 3-6',
  'games.grades4to8': 'Grados 4-8',
  'games.grades1to8': 'Grados 1-8',

  // Game Titles & Descriptions
  'games.emojiZoo': 'Zoológico de Emojis',
  'games.emojiZooDescription': 'Aprende sobre los animales y sus hábitats en esta aventura interactiva de zoológico.',
  'games.timeMachine.title': 'Máquina del Tiempo',
  'games.timeMachine.subtitle': 'Viaja a Través de la Historia',
  'games.geoMystery.title': 'Geo Mystery',
  'games.geoMystery.subtitle': 'Explora el Mundo',
  'games.drIA.title': 'Dr. IA',
  'games.drIA.subtitle': 'Explorador de Biología',
  'games.mathGames.title': 'Desafíos Matemáticos',
  'games.mathGames.subtitle': 'Domina los Números',

  // Secret Words
  'games.secretWords.errorGenerating': 'Error al generar las palabras. Por favor intenta de nuevo.',
  'common.changeLanguage': 'Cambiar idioma',
  'guiasPadres.hero.title': 'Cómo ayudamos a tu hijo a aprender mejor',
  'guiasPadres.hero.text': 'En TutorAI Kids no solo damos respuestas. Guiamos a los niños para que descubran las soluciones por sí mismos, construyendo confianza y habilidades de pensamiento crítico que les durarán toda la vida.',
  'guiasPadres.teachingMethodTitle': 'Nuestro Método de Enseñanza',
  'guiasPadres.method1.title': 'Método Socrático: Aprender Haciendo Preguntas',
  'guiasPadres.method1.text': 'En vez de dar respuestas directas, Miss Ann hace preguntas reflexivas que guían a tu hijo a pensar críticamente. Cuando tu hijo pregunta "¿Cuál es la respuesta?", Miss Ann responde con "¿Tú qué crees? Vamos a resolverlo juntos paso a paso." Este enfoque desarrolla habilidades de resolución de problemas y comprensión profunda.',
  'guiasPadres.method2.title': 'Ritmo de Aprendizaje Personalizado',
  'guiasPadres.method2.text': 'Cada niño aprende de forma diferente. Nuestra IA se adapta al ritmo único de aprendizaje de tu hijo, ofreciendo más apoyo cuando lo necesita y retándolo cuando está listo. Seguimos su progreso en tiempo real y ajustamos nuestro enfoque de enseñanza para maximizar los resultados.',
  'guiasPadres.method3.title': 'Refuerzo Positivo y Motivación',
  'guiasPadres.method3.text': 'Celebramos cada pequeño logro. Cuando tu hijo resuelve un problema, Miss Ann lo anima con entusiasmo usando emojis y comentarios positivos. Nuestro sistema de logros con insignias y recompensas mantiene a los niños motivados y comprometidos con su aprendizaje.',
  'guiasPadres.keyFeaturesTitle': 'Funciones Clave para Padres',
  'guiasPadres.feature1.title': 'Ayuda con Tareas Sin Hacer Trampa',
  'guiasPadres.feature1.text': 'Tu hijo puede subir fotos de su tarea, y Miss Ann analiza las preguntas. En vez de dar respuestas, hace preguntas guía como "¿Qué información tenemos?" y "¿Cuál es el primer paso?" Esto asegura que tu hijo realmente comprenda el material.',
  'guiasPadres.feature2.title': 'Panel de Padres en Tiempo Real',
  'guiasPadres.feature2.text': 'Monitorea el progreso de tu hijo con información detallada. Ve en qué materias está trabajando, cuánto tiempo dedica a aprender, en qué destaca y qué temas necesitan más atención. Recibirás reportes semanales con recomendaciones concretas.',
  'guiasPadres.feature3.title': 'Juegos Educativos que Enseñan',
  'guiasPadres.feature3.text': 'Aprender no tiene que ser aburrido. Nuestros juegos interactivos cubren matemáticas, lenguaje, ciencias y geografía. Cada juego está diseñado por educadores para reforzar conceptos del currículo mientras mantiene a los niños entretenidos.',
  'guiasPadres.feature4.title': 'Entorno Seguro y Protegido',
  'guiasPadres.feature4.text': 'La seguridad de tu hijo es nuestra prioridad. Todas las conversaciones son monitoreadas para asegurar contenido apropiado. Cumplimos con las regulaciones de protección de datos infantiles y nunca compartimos información personal. Los padres tienen total visibilidad de todas las interacciones.',
  'guiasPadres.safety.title': 'Qué Hace y Qué No Hace Miss Ann',
  'guiasPadres.safety.text': 'Miss Ann guía con preguntas, da pistas sin respuestas directas, se adapta al ritmo de cada estudiante, celebra el esfuerzo y el progreso, e identifica áreas que necesitan más práctica. Sin embargo, Miss Ann nunca da respuestas directas de tareas, nunca completa asignaciones por los estudiantes, nunca reemplaza a maestros o padres, y nunca guarda datos personales sin consentimiento.',
  'guiasPadres.whatParentsSayTitle': 'Lo Que Dicen los Padres',
  'guiasPadres.testimonial1.name': 'Jennifer Smith',
  'guiasPadres.testimonial1.role': 'Madre de 2',
  'guiasPadres.testimonial1.quote': 'Las notas de matemáticas de mi hijo mejoraron de C a A en solo 3 meses. La guía paciente de Miss Ann le ayudó a entender conceptos con los que llevaba años batallando.',
  'guiasPadres.testimonial2.name': 'Michael Johnson',
  'guiasPadres.testimonial2.role': 'Padre de 1',
  'guiasPadres.testimonial2.quote': 'El panel para padres es increíble. Puedo ver exactamente en qué está trabajando mi hija y dónde necesita ayuda. Es como tener un reporte de calificaciones del tutor todos los días.',
  'guiasPadres.testimonial3.name': 'Sarah Davis',
  'guiasPadres.testimonial3.role': 'Madre de 3',
  'guiasPadres.testimonial3.quote': '¡Mis hijos ahora esperan con ganas hacer la tarea! Los juegos y el sistema de logros convirtieron el aprendizaje en algo divertido. La mejor inversión en su educación.',
  'guiasPadres.finalCta.title': '¿Listo para Transformar el Aprendizaje de tu Hijo?',
  'guiasPadres.finalCta.subtitle': 'Únete a miles de padres que confían en TutorIA Kids para guiar a sus hijos hacia el éxito académico.',
  'guiasPadres.finalCta.button': 'Iniciar Prueba Gratuita de 3 Días',
  'guiasPadres.finalCta.footnote': '✓ No se requiere tarjeta de crédito  ✓ Cancela cuando quieras  ✓ Acceso completo a todas las funciones',
  'guiasPadres.footer.product': 'Producto',
  'guiasPadres.footer.meetTutors': 'Conoce a tus Tutores',
  'guiasPadres.footer.company': 'Compañía',
  'guiasPadres.footer.aboutUs': 'Sobre Nosotros',
  'featureGate.verifyingPlan': 'Verificando plan...',
  'featureGate.familyExclusive': 'Esta función avanzada es exclusiva del Plan Familiar.',
  'featureGate.upgradeNow': 'Actualizar Ahora',
  'featureGate.subscriptionPaused': 'Tu suscripción está pausada. Reactívala para recuperar el acceso a esta función.',
  'featureGate.reactivate': 'Reactivar',
  'featureGate.subscriptionCancelled': 'Tu suscripción ha sido cancelada. Suscríbete a un plan para acceder a esta función.',
  'featureGate.subscribe': 'Suscribirse',
  'featureGate.trialEnded': 'Tu prueba gratuita de 3 días ha terminado. ¡Actualiza al Plan Familiar para desbloquear esta función premium!',
  'featureGate.featureLocked': 'Función Bloqueada 🔒',
  'featureGate.familyBadge': 'Familiar',
  'featureGate.alreadyUpgraded': '¿Ya actualizaste?',
  'featureGate.refresh': 'Actualizar página',
  'games.secretWords.title': 'Palabras Secretas',
  'games.secretWords.subtitle': 'Adivina la palabra oculta con pistas de IA',
  'games.secretWords.exit': 'Salir',
  'games.secretWords.score': 'Puntuación',
  'games.secretWords.points': 'puntos',
  'games.secretWords.word': 'Palabra',
  'games.secretWords.attemptsRemaining': 'Intentos Restantes',
  'games.secretWords.generatingWords': 'Generando Palabras...',
  'games.secretWords.waitMessage': 'Estamos preparando tu desafío...',
  'games.secretWords.letters': 'letras',
  'games.secretWords.hint': 'Pista',
  'games.secretWords.visualHint': 'Pista Visual',
  'games.secretWords.needHelp': '¿Necesitas una pista?',
  'games.secretWords.viewFirstHint': 'Ver Primera Pista',
  'games.secretWords.viewSecondHint': 'Ver Segunda Pista',
  'games.secretWords.viewVisualHint': 'Ver Imagen',
  'games.secretWords.currentHint': 'Pista Actual',
  'games.secretWords.correct': '¡Correcto!',
  'games.secretWords.oopsLost': '¡Lo siento!',
  'games.secretWords.wordWas': 'La palabra era',
  'games.secretWords.definition': 'Definición',
  'games.secretWords.nextWord': 'Siguiente Palabra',
  'games.secretWords.finishGame': 'Finalizar Juego',
  'games.secretWords.tryAgain': 'Intentar de Nuevo',
  'games.secretWords.skipWord': 'Saltar Palabra',
  'games.secretWords.gameProgress': 'Progreso del Juego',
  'games.secretWords.of': 'de',
  'games.secretWords.words': 'palabras',
  'games.secretWords.subjects.science': 'Ciencias',
  'games.secretWords.subjects.math': 'Matemáticas',
  'games.secretWords.subjects.history': 'Historia',
  'games.secretWords.subjects.geography': 'Geografía',
  'games.secretWords.subjects.language': 'Lenguaje',

  // Game Features
  'games.adaptiveAI': 'IA Adaptativa',
  'games.adaptiveAIDescription': 'Ajusta la dificultad automáticamente para adaptarse a tu ritmo.',
  'games.effectiveLearning': 'Aprendizaje Efectivo',
  'games.effectiveLearningDescription': 'Basado en metodologías educativas comprobadas.',
  'games.progressTracking': 'Seguimiento del Progreso',
  'games.progressTrackingDescription': 'Monitorea tus logros y tu crecimiento a lo largo del tiempo.',

  // Emoji Zoo Game
  'games.zoo.title': 'Zoológico de Emojis',
  'games.zoo.subtitle': 'Descubre el Mundo Animal',
  'games.zoo.howToPlay': 'Cómo Jugar',
  'games.zoo.step1': 'Observa',
  'games.zoo.step1Desc': 'Mira con atención el emoji que aparece.',
  'games.zoo.step2': 'Adivina',
  'games.zoo.step2Desc': 'Elige el nombre correcto del animal.',
  'games.zoo.step3': 'Gana',
  'games.zoo.step3Desc': '¡Gana puntos y desbloquea nuevos niveles!',
  'games.zoo.selectDifficulty': 'Selecciona la Dificultad',
  'games.zoo.easy': 'Fácil',
  'games.zoo.easyDesc': 'Animales comunes, sin límite de tiempo.',
  'games.zoo.medium': 'Medio',
  'games.zoo.mediumDesc': 'Animales exóticos, 30 segundos.',
  'games.zoo.hard': 'Difícil',
  'games.zoo.hardDesc': 'Animales raros, 15 segundos.',
  'games.zoo.progress': 'Progreso',
  'games.zoo.letter': 'Letra',
  'games.zoo.whatStartsWith': 'Qué comienza con',
  'games.zoo.tapCorrect': '¡Toca el animal correcto!',
  'games.zoo.exit': 'Salir del Juego',
  'games.zoo.selected': 'Seleccionado',
  'games.zoo.gameFinished': '¡Juego Terminado!',
  'games.zoo.totalPoints': 'Puntos Totales',
  'games.zoo.champion': '¡Campeón!',
  'games.zoo.playAgain': 'Jugar de Nuevo',
  'games.zoo.mainMenu': 'Menú Principal',
  'games.zoo.correct': '¡Correcto!',
  'games.zoo.nextLetter': 'Siguiente Letra',
  'games.zoo.viewResults': 'Ver Resultados',
  'games.zoo.almostThere': '¡Casi lo logras!',
  'games.zoo.correctAnswer': 'Respuesta correcta:',
  'games.zoo.tryAgain': 'Intentar de Nuevo',
  'games.zoo.veryGood': '¡Muy Bien!',

  // Parent Guide
  'parentGuide.title': 'Guía para Padres',
  'parentGuide.subtitle': 'Todo lo que necesitas saber sobre TutorAI Kids',
  'parentGuide.badge': 'Para Padres',
  'parentGuide.quickNav.title': 'Navegación Rápida',
  'parentGuide.quickNav.howItWorks': 'Cómo Funciona',
  'parentGuide.quickNav.methodology': 'Metodología',
  'parentGuide.quickNav.features': 'Características',
  'parentGuide.quickNav.faq': 'FAQ',
  'parentGuide.howItWorks.title': '¿Cómo Funciona?',
  'parentGuide.howItWorks.subtitle': 'Un proceso simple diseñado para apoyar el aprendizaje',
  'parentGuide.howItWorks.step1.title': 'Tu Hijo Pregunta',
  'parentGuide.howItWorks.step1.description': 'Hola Tutor, no entiendo cómo resolver este problema de fracciones. ¿Puedes ayudarme?',
  'parentGuide.howItWorks.step2.title': 'La IA Guía',
  'parentGuide.howItWorks.step2.description': 'Nuestra IA no da respuestas directas. En su lugar, hace preguntas guiadas para ayudar a tu hijo a pensar y descubrir la solución por sí mismo.',
  'parentGuide.howItWorks.step3.title': 'Tu Hijo Aprende',
  'parentGuide.howItWorks.step3.description': 'A través de este proceso, tu hijo desarrolla pensamiento crítico, habilidades de resolución de problemas y gana confianza en sus capacidades.',
  'parentGuide.methodology.title': 'Nuestra Metodología',
  'parentGuide.methodology.subtitle': 'Basada en principios pedagógicos probados',
  'parentGuide.methodology.socratic.title': 'Método Socrático',
  'parentGuide.methodology.socratic.description': 'Usamos preguntas guiadas en lugar de respuestas directas, promoviendo el pensamiento crítico y la comprensión profunda.',
  'parentGuide.methodology.constructivism.title': 'Constructivismo',
  'parentGuide.methodology.constructivism.description': 'Los estudiantes construyen su propio conocimiento a través de la experiencia activa y la reflexión, no la memorización pasiva.',
  'parentGuide.methodology.scaffolding.title': 'Andamiaje',
  'parentGuide.methodology.scaffolding.description': 'Proporcionamos apoyo progresivo que se adapta al nivel de cada estudiante, aumentando gradualmente la independencia.',
  'parentGuide.transparency.title': 'Lo Que la IA Hace y No Hace',
  'parentGuide.transparency.subtitle': 'Transparencia total sobre cómo apoyamos el aprendizaje',
  'parentGuide.transparency.does.title': 'Lo Que Tutor IA HACE',
  'parentGuide.transparency.does.item1': 'Hace preguntas guiadas para estimular el pensamiento',
  'parentGuide.transparency.does.item2': 'Proporciona pistas y claves sin dar respuestas directas',
  'parentGuide.transparency.does.item3': 'Se adapta al ritmo de aprendizaje de cada estudiante',
  'parentGuide.transparency.does.item4': 'Celebra el esfuerzo y el progreso',
  'parentGuide.transparency.does.item5': 'Identifica áreas que necesitan más práctica',
  'parentGuide.transparency.doesnt.title': 'Lo Que Tutor IA NO HACE',
  'parentGuide.transparency.doesnt.item1': 'Dar respuestas directas a las tareas',
  'parentGuide.transparency.doesnt.item2': 'Completar asignaciones por los estudiantes',
  'parentGuide.transparency.doesnt.item3': 'Reemplazar al maestro o padre',
  'parentGuide.transparency.doesnt.item4': 'Tomar decisiones sobre la educación del niño',
  'parentGuide.transparency.doesnt.item5': 'Almacenar datos personales sin consentimiento',
  'parentGuide.features.title': 'Características Clave',
  'parentGuide.features.subtitle': 'Herramientas diseñadas para padres y estudiantes',
  'parentGuide.features.dashboard.title': 'Panel para Padres',
  'parentGuide.features.dashboard.description': 'Monitorea el progreso de tu hijo en tiempo real. Ve en qué materias está trabajando, sus logros y áreas que necesitan más atención.',
  'parentGuide.features.games.title': 'Juegos Educativos',
  'parentGuide.features.games.description': 'Aprendizaje a través del juego. Juegos interactivos que refuerzan conceptos en matemáticas, lenguaje, ciencias y más, todos alineados con el currículo.',
  'parentGuide.features.studyPlan.title': 'Plan de Estudio Inteligente',
  'parentGuide.features.studyPlan.description': 'La IA crea un plan de estudio personalizado basado en las fortalezas y áreas de mejora de tu hijo, adaptándose a medida que progresa.',
  'parentGuide.gettingStarted.title': 'Cómo Comenzar',
  'parentGuide.gettingStarted.subtitle': '4 pasos simples para empezar',
  'parentGuide.gettingStarted.step1.title': 'Crear Cuenta',
  'parentGuide.gettingStarted.step1.description': 'Regístrate y crea un perfil para tu hijo en menos de 2 minutos.',
  'parentGuide.gettingStarted.step2.title': 'Configurar Preferencias',
  'parentGuide.gettingStarted.step2.description': 'Selecciona el nivel de grado, materias de interés y objetivos de aprendizaje.',
  'parentGuide.gettingStarted.step3.title': 'Explorar Juntos',
  'parentGuide.gettingStarted.step3.description': 'Pasa las primeras sesiones con tu hijo para familiarizarlo con la plataforma.',
  'parentGuide.gettingStarted.step4.title': 'Monitorear Progreso',
  'parentGuide.gettingStarted.step4.description': 'Revisa el panel regularmente para ver el progreso y celebrar los logros.',
  'parentGuide.faq.title': 'Preguntas Frecuentes',
  'parentGuide.faq.q1.question': '¿Es seguro que mi hijo use IA?',
  'parentGuide.faq.q1.answer': 'Sí, completamente seguro. TutorAI Kids está diseñada específicamente para niños, con filtros de contenido y supervisión constante. No almacenamos conversaciones personales y cumplimos con todas las regulaciones de protección de datos infantiles.',
  'parentGuide.faq.q2.question': '¿La IA hará las tareas de mi hijo?',
  'parentGuide.faq.q2.answer': 'No. Nuestra IA está diseñada para guiar, no para dar respuestas directas. Usa el método socrático, haciendo preguntas que ayudan a tu hijo a pensar y encontrar soluciones por sí mismo.',
  'parentGuide.faq.q3.question': '¿Cuánto tiempo debe pasar mi hijo en la plataforma?',
  'parentGuide.faq.q3.answer': 'Recomendamos sesiones de 20-30 minutos, 3-4 veces por semana. La plataforma incluye recordatorios y límites de tiempo para promover un uso saludable.',
  'parentGuide.faq.q4.question': '¿Qué pasa si mi hijo se queda atascado?',
  'parentGuide.faq.q4.answer': 'La IA está diseñada para detectar frustración y ajustar su enfoque. Si un estudiante realmente está atascado, el sistema te notifica para que puedas proporcionar apoyo adicional.',

  // FAQ Page
  'faqPage.title': 'Preguntas Frecuentes',
  'faqPage.subtitle': 'Encuentra respuestas a las dudas comunes sobre TutorAI Kids',
  'faqPage.searchPlaceholder': 'Buscar preguntas...',
  'faqPage.categories.all': 'Todas',
  'faqPage.categories.general': 'General',
  'faqPage.categories.methodology': 'Metodología',
  'faqPage.categories.pricing': 'Precios',
  'faqPage.categories.safety': 'Seguridad',
  'faqPage.categories.technical': 'Técnico',
  'faqPage.cta.title': '¿Aún tienes preguntas?',
  'faqPage.cta.text': 'Nuestro equipo de soporte está aquí para ayudarte.',
  'faqPage.cta.button': 'Contactar Soporte',

  // FAQ Items - General
  'faqPage.q.general.1': '¿Qué es TutorAI Kids?',
  'faqPage.a.general.1': 'TutorAI Kids es una plataforma educativa inteligente diseñada para niños de 5 a 12 años. Utiliza IA para guiar a los estudiantes en sus tareas y proceso de aprendizaje sin dar respuestas directas, promoviendo el pensamiento crítico.',
  'faqPage.q.general.2': '¿Para qué edades es?',
  'faqPage.a.general.2': 'Nuestra plataforma está optimizada para estudiantes de primaria y secundaria, típicamente de 5 a 12 años. El contenido y la interfaz se adaptan al grado del niño.',
  'faqPage.q.general.3': '¿Está disponible en otros idiomas?',
  'faqPage.a.general.3': 'Sí, TutorAI Kids es completamente bilingüe (Inglés y Español). Puedes cambiar el idioma en cualquier momento desde la configuración.',

  // FAQ Items - Methodology
  'faqPage.q.methodology.1': '¿La IA hace la tarea por mi hijo?',
  'faqPage.a.methodology.1': 'No. Este es un principio fundamental de nuestra plataforma. Nuestra IA utiliza el método socrático: hace preguntas guiadas y da pistas para ayudar a tu hijo a descubrir la respuesta por sí mismo, pero nunca proporciona la solución directa.',
  'faqPage.q.methodology.2': '¿Cómo sabe la IA qué está estudiando mi hijo?',
  'faqPage.a.methodology.2': 'Los estudiantes pueden subir fotos de sus tareas o libros de texto. Nuestra IA analiza la imagen, entiende el contexto y comienza una sesión de tutoría guiada basada en ese material específico.',

  // FAQ Items - Pricing
  'faqPage.q.pricing.1': '¿Cómo funciona la prueba gratuita?',
  'faqPage.a.pricing.1': 'Ofrecemos una prueba gratuita de 3 días con acceso completo. No necesitas ingresar una tarjeta de crédito para comenzar. Después de 3 días, puedes elegir un plan de suscripción para continuar.',
  'faqPage.q.pricing.2': '¿Puedo cancelar en cualquier momento?',
  'faqPage.a.pricing.2': 'Sí, absolutamente. No hay contratos a largo plazo. Puedes cancelar tu suscripción instantáneamente desde tu perfil en el panel.',
  'faqPage.q.pricing.3': '¿Ofrecen planes familiares?',
  'faqPage.a.pricing.3': '¡Sí! Nuestro Plan Familiar ($59.99/mes) cubre hasta 3 estudiantes, haciéndolo perfecto para hermanos.',

  // FAQ Items - Safety
  'faqPage.q.safety.1': '¿Es seguro para los niños?',
  'faqPage.a.safety.1': 'La seguridad es nuestra máxima prioridad. Nuestra IA está filtrada para ser estrictamente educativa y apropiada para la edad. Cumplimos con COPPA y no vendemos datos.',
  'faqPage.q.safety.2': '¿Hay anuncios?',
  'faqPage.a.safety.2': 'No. TutorAI Kids es un entorno completamente libre de anuncios para asegurar que tu hijo permanezca enfocado en aprender.',

  // FAQ Items - Technical
  'faqPage.q.technical.1': '¿Qué dispositivos puedo usar?',
  'faqPage.a.technical.1': 'TutorAI Kids funciona en cualquier dispositivo con un navegador web: computadoras (Windows/Mac), tabletas (iPad/Android) y teléfonos inteligentes.',
  'faqPage.q.technical.2': '¿Puedo usarlo sin conexión?',
  'faqPage.a.technical.2': 'Se requiere una conexión a Internet para interactuar con el tutor de IA y cargar los juegos educativos.',
  'privacy.protection4Title': 'Eliminación de Datos',
  'privacy.protection4Text': 'Procesos de eliminación segura cuando los datos ya no son necesarios.',
  'privacy.aiSafetyTitle': 'Seguridad de IA e Integridad de Datos',
  'privacy.aiSafety1Title': 'Sin Entrenamiento de IA',
  'privacy.aiSafety1Text': 'Los datos de los estudiantes NUNCA se utilizan para entrenar modelos públicos de IA.',
  'privacy.aiSafety2Title': 'No Venta de Datos',
  'privacy.aiSafety2Text': 'Nunca vendemos la información personal de su hijo a terceros ni la utilizamos para publicidad comportamental.',
  'privacy.right3Text': 'Eliminar la cuenta y datos de tu hijo.',
  'privacy.operatorTitle': 'Información del Operador',
  'privacy.operatorAddress': '3007 Rosebud Lane, Brandon, FL 33511, Estados Unidos',
  'privacy.operatorText': 'Este servicio es operado por Neo AI Estudio. Para consultas de privacidad, contáctanos en privacy@tutoraikids.com. Para soporte general, contacta support@tutoraikids.com.',
  'privacy.aiSafety3Title': 'Proveedores de Confianza',
  'privacy.aiSafety3Text': 'Compartimos datos estrictamente necesarios con proveedores de confianza (ej. Stripe para pagos, Google Gemini para IA educativa) únicamente para la prestación del servicio, bajo estrictos acuerdos de confidencialidad.',
  'privacy.aiSafety4Title': 'Seguridad y Encriptación',
  'privacy.aiSafety4Text': 'Todos los datos están encriptados en tránsito (SSL/TLS) y en reposo. Solo personal autorizado tiene acceso a información sensible, con controles de acceso estrictos y auditorías regulares.',
  'privacy.dataRetentionTitle': 'Política de Retención de Datos',
  'privacy.dataRetentionText': 'Los datos personales se conservan únicamente durante el tiempo necesario para proporcionar nuestros servicios educativos. Los datos de sesiones académicas se conservan para seguimiento del progreso mientras la cuenta esté activa. Los padres pueden solicitar la eliminación completa de los datos en cualquier momento, y estos serán eliminados dentro de 30 días, excepto cuando la ley requiera su retención.',
  'parentGuide.faq.q5.question': '¿Puedo ver lo que está haciendo mi hijo?',
  'parentGuide.faq.q5.answer': 'Sí! El panel para padres te muestra todas las actividades, progreso, tiempo dedicado y áreas donde tu hijo está sobresaliendo o necesita más apoyo.',
  'parentGuide.faq.q6.question': '¿Reemplaza al maestro?',
  'parentGuide.faq.q6.answer': 'Nunca. Nuestra IA es una herramienta complementaria que refuerza lo aprendido en la escuela. Creemos en el valor irremplazable de los maestros y la interacción humana en la educación.',
  'parentGuide.cta.title': '¿Listo para Apoyar el Aprendizaje de Tu Hijo?',
  'parentGuide.cta.subtitle': 'Únete a miles de padres que confían en la IA para mejorar la educación de sus hijos',
  'parentGuide.cta.trial': 'Prueba gratuita de 3 días • No se requiere tarjeta de crédito',
  'parentGuide.cta.startTrial': 'Comenzar Prueba Gratuita',
  'parentGuide.cta.viewDemo': 'Ver Demo',
  'parentGuide.cta.description': 'Únete a miles de familias que ya están usando TutorAI Kids para ayudar a sus hijos a tener éxito académico.',
  'parentGuide.cta.button': 'Comenzar Prueba Gratuita',
  'parentGuide.cta.features': 'Acceso completo a todas las funciones • Cancela en cualquier momento • Soporte 24/7',
  'parentGuide.hero.title': 'Empodera el Aprendizaje de Tu Hijo con IA',
  'parentGuide.hero.description': 'Descubre cómo TutorAI Kids utiliza inteligencia artificial avanzada para ayudar a tu hijo a aprender de manera efectiva, desarrollar pensamiento crítico y alcanzar su máximo potencial académico.',
  'parentGuide.hero.cta': 'Comenzar Prueba Gratuita',
  'parentGuide.socratic.title': 'El Método Socrático: Aprender Haciendo Preguntas',
  'parentGuide.socratic.description': 'Nuestro tutor de IA no da respuestas directas. En su lugar, guía a tu hijo a través de preguntas reflexivas que fomentan el pensamiento crítico y la comprensión profunda. Este método probado ayuda a los estudiantes a desarrollar habilidades de resolución de problemas que duran toda la vida.',
  'parentGuide.socratic.benefit1.title': 'Pensamiento Crítico',
  'parentGuide.socratic.benefit1.description': 'Los estudiantes aprenden a analizar problemas y encontrar soluciones por sí mismos',
  'parentGuide.socratic.benefit2.title': 'Comprensión Profunda',
  'parentGuide.socratic.benefit2.description': 'Las preguntas guiadas ayudan a los estudiantes a comprender conceptos, no solo memorizarlos',
  'parentGuide.socratic.benefit3.title': 'Confianza',
  'parentGuide.socratic.benefit3.description': 'Descubrir respuestas por sí mismos aumenta la autoestima y la motivación',
  'parentGuide.personalized.title': 'Aprendizaje Personalizado para Cada Niño',
  'parentGuide.personalized.description': 'Cada niño aprende de manera diferente. Nuestra IA se adapta al ritmo, estilo de aprendizaje y nivel de comprensión único de tu hijo, proporcionando apoyo personalizado que se ajusta a sus necesidades.',
  'parentGuide.personalized.feature1.title': 'Ritmo Adaptativo',
  'parentGuide.personalized.feature1.description': 'La IA ajusta la dificultad según el progreso de tu hijo',
  'parentGuide.personalized.feature2.title': 'Múltiples Estilos',
  'parentGuide.personalized.feature2.description': 'Soporta aprendizaje visual, auditivo y kinestésico',
  'parentGuide.personalized.feature3.title': 'Retroalimentación Instantánea',
  'parentGuide.personalized.feature3.description': 'Correcciones y guía inmediata para mantener el impulso',
  'parentGuide.motivation.title': 'Sistema de Motivación que Funciona',
  'parentGuide.motivation.description': 'Mantener a los niños motivados es clave para el éxito del aprendizaje. Nuestro sistema de logros, insignias y recompensas hace que el aprendizaje sea divertido y gratificante.',
  'parentGuide.motivation.element1.title': 'Logros Desbloqueables',
  'parentGuide.motivation.element1.description': 'Los estudiantes ganan insignias por completar desafíos y alcanzar hitos',
  'parentGuide.motivation.element2.title': 'Seguimiento de Progreso',
  'parentGuide.motivation.element2.description': 'Visualiza el crecimiento con gráficos y estadísticas atractivas',
  'parentGuide.motivation.element3.title': 'Celebración de Éxitos',
  'parentGuide.motivation.element3.description': 'Cada logro se celebra con animaciones y mensajes positivos',
  'parentGuide.homework.title': 'Ayuda con Tareas Sin Hacer Trampa',
  'parentGuide.homework.description': 'Preocupado de que tu hijo solo copie respuestas? No lo estés. Nuestro tutor de IA está diseñado específicamente para guiar, no para dar respuestas. Así es como funciona:',
  'parentGuide.homework.step1.title': 'Sube una Foto',
  'parentGuide.homework.step1.description': 'Tu hijo toma una foto de su tarea',
  'parentGuide.homework.step2.title': 'IA Analiza',
  'parentGuide.homework.step2.description': 'El tutor identifica el tema y el nivel de dificultad',
  'parentGuide.homework.step3.title': 'Preguntas Guiadas',
  'parentGuide.homework.step3.description': 'La IA hace preguntas que llevan a tu hijo a la respuesta',
  'parentGuide.homework.step4.title': 'Aprende Haciendo',
  'parentGuide.homework.step4.description': 'Tu hijo descubre la solución por sí mismo',
  'parentGuide.parentDashboard.title': 'Dashboard para Padres: Mantente Informado',
  'parentGuide.parentDashboard.description': 'Monitorea el progreso de tu hijo, revisa sesiones de tutoría y celebra logros, todo desde tu dashboard personalizado.',
  'parentGuide.parentDashboard.feature1.title': 'Seguimiento en Tiempo Real',
  'parentGuide.parentDashboard.feature1.description': 'Ve qué está estudiando tu hijo y cuánto tiempo dedica',
  'parentGuide.parentDashboard.feature2.title': 'Reportes de Progreso',
  'parentGuide.parentDashboard.feature2.description': 'Reportes detallados sobre fortalezas y áreas de mejora',
  'parentGuide.parentDashboard.feature3.title': 'Historial de Sesiones',
  'parentGuide.parentDashboard.feature3.description': 'Revisa conversaciones pasadas y temas cubiertos',
  'parentGuide.parentDashboard.feature4.title': 'Notificaciones',
  'parentGuide.parentDashboard.feature4.description': 'Recibe alertas sobre logros y hitos importantes',
  'parentGuide.educationalGames.title': 'Juegos Educativos que Enseñan',
  'parentGuide.educationalGames.description': 'El aprendizaje no tiene que ser aburrido. Nuestros juegos educativos hacen que practicar matemáticas, ciencias, historia y más sea divertido y atractivo.',
  'parentGuide.educationalGames.game1.title': 'Máquina del Tiempo',
  'parentGuide.educationalGames.game1.description': 'Viaja a través de la historia y chatea con figuras históricas',
  'parentGuide.educationalGames.game2.title': 'Palabras Secretas',
  'parentGuide.educationalGames.game2.description': 'Mejora el vocabulario con desafíos de palabras impulsados por IA',
  'parentGuide.educationalGames.game3.title': 'Geo Mystery',
  'parentGuide.educationalGames.game3.description': 'Explora geografía resolviendo misterios de ubicación',
  'parentGuide.educationalGames.game4.title': 'Dr. IA',
  'parentGuide.educationalGames.game4.description': 'Aprende biología diagnosticando casos médicos virtuales',
  'parentGuide.educationalGames.game5.title': 'Desafíos Matemáticos',
  'parentGuide.educationalGames.game5.description': 'Domina las matemáticas con juegos interactivos y divertidos',
  'parentGuide.educationalGames.game6.title': 'Zoológico de Emojis',
  'parentGuide.educationalGames.game6.description': 'Aprende sobre animales de manera divertida y creativa',
  'parentGuide.safety.title': 'Seguridad y Privacidad Primero',
  'parentGuide.safety.description': 'La seguridad de tu hijo es nuestra máxima prioridad. Así es como protegemos a tu familia:',
  'parentGuide.safety.measure1.title': 'Contenido Filtrado',
  'parentGuide.safety.measure1.description': 'Toda la IA está entrenada para proporcionar solo contenido apropiado para la edad',
  'parentGuide.safety.measure2.title': 'Sin Anuncios',
  'parentGuide.safety.measure2.description': 'Entorno de aprendizaje 100% libre de anuncios',
  'parentGuide.safety.measure3.title': 'Datos Encriptados',
  'parentGuide.safety.measure3.description': 'Toda la información del estudiante está encriptada y segura',
  'parentGuide.safety.measure4.title': 'Control Parental',
  'parentGuide.safety.measure4.description': 'Los padres tienen acceso completo y control sobre las cuentas de los niños',
  'parentGuide.testimonials.title': 'Lo Que Dicen Otros Padres',
  'parentGuide.testimonial1.text': 'TutorAI Kids ha transformado la forma en que mi hija aborda las tareas. Ya no lucha sola, tiene un tutor paciente disponible 24/7. Sus calificaciones han mejorado y realmente disfruta aprender ahora.',
  'parentGuide.testimonial1.author': 'Sarah M.',
  'parentGuide.testimonial1.role': 'Madre de estudiante de 5to grado',
  'parentGuide.testimonial2.text': 'Como padre ocupado, no siempre puedo ayudar con las tareas. TutorAI Kids llena ese vacío perfectamente. Me encanta que no solo da respuestas, sino que enseña a mi hijo a pensar críticamente.',
  'parentGuide.testimonial2.author': 'Michael R.',
  'parentGuide.testimonial2.role': 'Padre de estudiante de 3er grado',
  'parentGuide.testimonial3.text': 'Los juegos educativos son increíbles! Mi hijo piensa que está jugando, pero en realidad está aprendiendo. El dashboard me permite ver su progreso y celebrar sus logros juntos.',
  'parentGuide.testimonial3.author': 'Jennifer L.',
  'parentGuide.testimonial3.role': 'Madre de estudiante de 2do grado',

  // Support Widget
  'support.welcome': '👋 ¡Hola! Soy el Soporte de TutorAI. ¿En qué puedo ayudarte hoy?',
  'support.title': 'Soporte TutorAI',
  'support.subtitle': 'Respondemos al instante',
  'support.placeholder': 'Escribe tu duda...',
  'support.error': 'Lo siento, tengo problemas de conexión. Inténtalo de nuevo.',
  'support.connectionError': 'Tengo problemas para conectar. Por favor verifica tu internet. 🔌',

  // Privacy Policy
  'privacy.coppaCompliant': 'Cumple con COPPA',
  'privacy.title': 'Política de Privacidad',
  'privacy.subtitle': 'Nos tomamos muy en serio tu privacidad y la seguridad de tus hijos.',
  'privacy.lastUpdated': 'Última actualización',
  'privacy.coppaBadgeTitle': 'Certificado COPPA',
  'privacy.coppaBadgeText': 'Cumplimos estrictamente con la Ley de Protección de la Privacidad Infantil en Línea (COPPA) para garantizar un entorno seguro para tus hijos.',
  'privacy.keyRequirements': 'Requisitos Clave',
  'privacy.requirement1Title': 'Política de Privacidad Clara',
  'privacy.requirement1Text': 'Mantenemos una política de privacidad clara y accesible que describe nuestras prácticas de manejo de información.',
  'privacy.requirement2Title': 'Consentimiento Parental Verificable',
  'privacy.requirement2Text': 'Requerimos el consentimiento parental verificable antes de recopilar cualquier información personal de los niños.',
  'privacy.requirement2Item1': 'Verificación con tarjeta de crédito',
  'privacy.requirement2Item2': 'Confirmación por correo electrónico',
  'privacy.requirement2Item3': 'Formulario de consentimiento firmado',
  'privacy.requirement2Item4': 'Verificación de identificación oficial (opcional)',
  'privacy.requirement3Title': 'Aviso a los Padres',
  'privacy.requirement3Text': 'Brindamos un aviso directo a los padres sobre nuestras prácticas de manejo de información relacionadas con los niños.',
  'privacy.requirement4Title': 'Minimización de Datos',
  'privacy.requirement4Text': 'Solo recopilamos la información razonablemente necesaria para que el niño participe en la actividad.',
  'privacy.requirement5Title': 'Derechos de los Padres',
  'privacy.requirement5Text': 'Los padres tienen control total sobre los datos de su hijo.',
  'privacy.requirement5Item1': 'Revisar la información personal',
  'privacy.requirement5Item2': 'Solicitar la eliminación',
  'privacy.requirement5Item3': 'Revocar el consentimiento',
  'privacy.requirement5Item4': 'Impedir la recopilación adicional',
  'privacy.requirement6Title': 'Retención de Datos',
  'privacy.requirement6Text': 'Conservamos la información solo durante el tiempo necesario para cumplir con el propósito para el cual fue recopilada.',
  'privacy.whoNeedsTitle': '¿Quién Debe Cumplir?',
  'privacy.whoNeedsText1': 'Los operadores de sitios web comerciales y servicios en línea dirigidos a niños menores de 13 años.',
  'privacy.whoNeedsText2': 'Cumplimos totalmente con estas regulaciones.',
  'privacy.dataCollectionTitle': 'Qué Datos Recopilamos',
  'privacy.parentInfoTitle': 'Información de los Padres',
  'privacy.parentInfo1': 'Nombre y Correo Electrónico',
  'privacy.parentInfo2': 'Información de Pago',
  'privacy.parentInfo3': 'Datos de Contacto',
  'privacy.childInfoTitle': 'Información del Niño',
  'privacy.childInfo1': 'Primer Nombre (o Apodo)',
  'privacy.childInfo2': 'Edad/Grado Escolar',
  'privacy.childInfo3': 'Preferencias de Aprendizaje',
  'privacy.childInfo4': 'Progreso Académico',
  'privacy.childInfo5': 'Interacciones de Chat (para la tutoría)',
  'privacy.notCollectedTitle': 'Lo Que NO Recopilamos',
  'privacy.notCollected1': 'Dirección Física Completa',
  'privacy.notCollected2': 'Número de Teléfono',
  'privacy.notCollected3': 'Fotos o Videos',
  'privacy.notCollected4': 'Enlaces a Redes Sociales',
  'privacy.notCollected5': 'Datos Biométricos',
  'privacy.protectionTitle': 'Cómo Protegemos los Datos',
  'privacy.protection1Title': 'Encriptación',
  'privacy.protection1Text': 'Todos los datos están encriptados en tránsito y en reposo, siguiendo los estándares de la industria.',
  'privacy.protection2Title': 'Control de Acceso',
  'privacy.protection2Text': 'Controles de acceso estrictos garantizan que solo el personal autorizado pueda acceder a los datos.',
  'privacy.protection3Title': 'Monitoreo',
  'privacy.protection3Text': 'Monitoreo continuo de amenazas y vulnerabilidades de seguridad.',
  'privacy.parentalRightsTitle': 'Tus Derechos como Padre o Madre',
  'privacy.parentalRightsText': 'Tienes control total sobre la cuenta y los datos de tu hijo.',
  'privacy.right1Title': 'Acceso',
  'privacy.right1Text': 'Revisar cualquier información recopilada.',
  'privacy.right2Title': 'Corrección',
  'privacy.right2Text': 'Actualizar o corregir información inexacta.',
  'privacy.right3Title': 'Eliminación',
  'privacy.right4Title': 'Control',
  'privacy.right4Text': 'Gestiona la configuración de consentimiento en cualquier momento.',
  'privacy.contactTitle': 'Contáctanos',
  'privacy.contactText': 'Si tienes alguna pregunta sobre nuestras prácticas de privacidad, contáctanos.',
  'privacy.contactEmail': 'Correo Electrónico',
  'privacy.contactResponseTime': 'Tiempo de Respuesta',
  'privacy.contactResponseValue': 'Dentro de 24 horas',
  'privacy.contactOfficer': 'Oficial de Privacidad',
  'privacy.contactOfficerValue': 'Robert Smith',
  'privacy.updatesTitle': 'Actualizaciones de la Política',
  'privacy.updatesText': 'Podemos actualizar esta política de privacidad de vez en cuando. Te notificaremos sobre cualquier cambio importante.',
  'privacy.ctaButton': 'Crear Cuenta Gratuita',
  'privacy.ctaText': 'Únete a miles de padres que confían en nosotros.',
  'privacy.footerDescription': 'Tutoría con IA segura para niños.',
  'privacy.footerPrivacy': 'Política de Privacidad',
  'privacy.footerTerms': 'Términos de Servicio',
  'privacy.footerHome': 'Inicio',

  // Terms of Service
  'terms.title': 'Términos de Servicio',
  'terms.subtitle': 'Por favor lee estos términos cuidadosamente antes de usar nuestros servicios.',
  'terms.lastUpdated': 'Última actualización',
  'terms.badge': 'Acuerdo Legal',
  'terms.intro': 'Al acceder o usar TutorAI Kids, un producto de Neo AI Estudio, aceptas estar sujeto a estos Términos de Servicio y nuestra Política de Privacidad.',
  'terms.section1.title': '1. Aceptación de Términos',
  'terms.section1.text': 'Al acceder y usar nuestra plataforma, aceptas y acuerdas estar sujeto a los términos y provisiones de este acuerdo. Si no estás de acuerdo con estos términos, por favor no uses este servicio.',
  'terms.section2.title': '2. Descripción del Servicio',
  'terms.section2.text': 'TutorAI Kids proporciona una plataforma educativa impulsada por IA para niños. Nos reservamos el derecho de modificar, suspender o discontinuar el servicio en cualquier momento sin previo aviso.',
  'terms.section3.title': '3. Cuentas de Usuario',
  'terms.section3.text': 'Eres responsable de mantener la confidencialidad de tu cuenta y contraseña. Aceptas la responsabilidad de todas las actividades que ocurran bajo tu cuenta o contraseña.',
  'terms.section4.title': '4. Conducta del Usuario',
  'terms.section4.text': 'Aceptas no usar el servicio para ningún propósito ilegal o de cualquier manera que interrumpa, dañe o perjudique el servicio. El acoso, abuso o cualquier comportamiento inapropiado hacia la IA u otros usuarios está estrictamente prohibido.',
  'terms.section5.title': '5. Propiedad Intelectual',
  'terms.section5.text': 'Todo el contenido incluido en este sitio, como texto, gráficos, logotipos, imágenes y software, es propiedad de TutorAI Kids o sus proveedores de contenido y está protegido por las leyes internacionales de derechos de autor.',
  'terms.section6.title': '6. Terminación',
  'terms.section6.text': 'Podemos terminar o suspender el acceso a nuestro servicio inmediatamente, sin previo aviso o responsabilidad, por cualquier motivo, incluyendo sin limitación si incumples los Términos.',
  'terms.section7.title': '7. Limitación de Responsabilidad',
  'terms.section7.text': 'En ningún caso Neo AI Estudio, su producto TutorAI Kids, ni sus directores, empleados, socios, agentes, proveedores o afiliados, serán responsables de daños indirectos, incidentales, especiales, consecuentes o punitivos. No garantizamos resultados académicos específicos, calificaciones de exámenes o resultados educativos por usar nuestros servicios de tutoría de IA.',
  'terms.section8.title': '8. Responsabilidad Parental y Requisitos de Edad',
  'terms.section8.text': 'TutorAI Kids está diseñado para niños menores de 13 años. Las cuentas deben ser creadas y administradas por un padre o tutor legal mayor de 18 años. Al crear una cuenta, confirmas que eres el padre o tutor legal y aceptas la responsabilidad total de todas las actividades bajo tu cuenta. Los niños no pueden crear cuentas de forma independiente.',
  'terms.section8.coppaText': 'Al crear una cuenta y registrar a tu hijo/a, otorgas tu consentimiento parental verificable, según lo exige la Ley de Protección de la Privacidad Infantil en Línea (COPPA), para la recopilación y el uso de la información de tu hijo/a necesaria para brindar el servicio. Puedes revisar, corregir o solicitar la eliminación de esa información en cualquier momento. Los detalles completos sobre qué datos recopilamos, cómo los usamos y cómo los protegemos están en nuestra',
  'terms.section9.title': '9. Tecnología de IA y Descargos',
  'terms.section9.text': 'TutorAI Kids utiliza tecnología de inteligencia artificial avanzada (incluyendo Google Gemini) para proporcionar tutoría educativa. Reconoces que la IA es una tecnología en desarrollo y puede generar contenido inexacto, incompleto o inapropiado. El contenido generado por IA se proporciona "tal cual" sin garantías de ningún tipo. TutorAI Kids no es un sustituto del asesoramiento educativo profesional ni de tutores humanos. Los padres deben supervisar las interacciones de sus hijos con la IA.',
  'terms.section10.title': '10. Uso Aceptable de la IA',
  'terms.section10.text': 'Aceptas usar la tecnología de IA únicamente con fines educativos. Las actividades prohibidas incluyen: intentar "jailbreak" o manipular la IA para generar contenido inapropiado, usar el servicio para fines no educativos, compartir el acceso a la cuenta con partes no autorizadas, o intentar realizar ingeniería inversa de nuestros sistemas de IA. Las violaciones pueden resultar en la suspensión inmediata de la cuenta.',
  'terms.section11.title': '11. Propiedad de Contenido y Licencias',
  'terms.section11.text': 'Conservas la propiedad de todo el contenido que ingreses en TutorAI Kids (preguntas, cargas de tareas, etc.). El contenido generado por IA (respuestas de tutoría, materiales de estudio) sigue siendo propiedad de TutorAI Kids, pero te otorgamos una licencia personal no comercial para usarlo con fines educativos. No puedes vender, distribuir o explotar comercialmente el contenido generado por IA sin nuestro permiso por escrito.',
  'terms.section12.title': '12. Pagos, Suscripciones y Reembolsos',
  'terms.section12.text': 'Las suscripciones se renuevan automáticamente al final de cada período de facturación a menos que se cancelen. Puedes cancelar en cualquier momento a través de la configuración de tu cuenta, efectivo al final del período de facturación actual. Los reembolsos están disponibles dentro de los 7 días posteriores a la compra inicial, prorrateados por cualquier uso. Utilizamos Stripe para procesar pagos de forma segura; no almacenamos información de tarjetas de crédito. Los precios de suscripción están sujetos a cambios con 30 días de aviso. Todos los precios se muestran en Dólares Estadounidenses (USD) y representan el monto total que se cobra; actualmente no agregamos impuestos por separado (como el impuesto sobre las ventas) al momento del pago. Si esto cambiara en el futuro, cualquier impuesto aplicable se mostraría claramente antes de confirmar tu pago.',
  'terms.section13.title': '13. Resolución de Disputas y Ley Aplicable',
  'terms.section13.text': 'Estos Términos se rigen por las leyes del Estado de Florida, Estados Unidos. Cualquier disputa que surja de estos Términos o tu uso de TutorAI Kids (un producto de Neo AI Estudio) se resolverá mediante arbitraje vinculante, excepto donde esté prohibido por ley. Renuncias al derecho de participar en demandas colectivas. Para cualquier asunto legal, contáctanos en legal@tutoraikids.com antes de iniciar procedimientos formales.',
  'terms.section14.title': '14. Modificaciones a Estos Términos',
  'terms.section14.text': 'Podemos actualizar estos Términos de Servicio de vez en cuando. Si hacemos cambios significativos, te notificaremos mediante un aviso visible en la plataforma o por correo electrónico antes de que los cambios entren en vigor. La fecha de "última actualización" en la parte superior de esta página siempre refleja la versión vigente. El uso continuado de la plataforma después de que un cambio entre en vigor constituye tu aceptación de los términos actualizados.',
  'terms.contact.title': 'Contáctanos',
  'terms.contact.text': 'Si tienes alguna pregunta sobre estos Términos, contáctanos.',
  'terms.contact.email': 'support@tutoraikids.com',
  'terms.contact.address': 'Neo AI Estudio, 3007 Rosebud Lane, Brandon, FL 33511, Estados Unidos',

  // Accesibilidad
  'accessibility.badge': 'Compromiso de Accesibilidad',
  'accessibility.title': 'Declaración de Accesibilidad',
  'accessibility.subtitle': 'Queremos que TutorIA Kids sea usable por todas las familias, incluyendo niños y padres con discapacidades.',
  'accessibility.lastUpdated': 'Última actualización',
  'accessibility.intro': 'En Neo AI Estudio creemos que la educación asistida por IA debe estar al alcance de todos los niños, sin importar sus capacidades. Esta página describe nuestro compromiso con la accesibilidad, lo que hemos implementado hasta ahora, y cómo puedes reportarnos un problema.',
  'accessibility.section1.title': '1. Nuestro Compromiso',
  'accessibility.section1.text': 'Trabajamos de forma continua para que TutorIA Kids sea perceptible, operable, comprensible y robusta para el mayor número posible de usuarios, incluyendo personas que usan tecnología de asistencia como lectores de pantalla, navegación por teclado o software de ampliación de texto.',
  'accessibility.section2.title': '2. Estándar que Seguimos',
  'accessibility.section2.text': 'Usamos las Pautas de Accesibilidad para el Contenido Web (WCAG) 2.1, nivel AA, como referencia para el diseño y desarrollo de la plataforma. Es un objetivo hacia el que trabajamos activamente, no una certificación formal ya obtenida.',
  'accessibility.section3.title': '3. Medidas que Hemos Implementado',
  'accessibility.section3.item1': 'Estructura semántica en HTML (encabezados, botones y enlaces reales en vez de elementos genéricos)',
  'accessibility.section3.item2': 'Textos alternativos en íconos e imágenes con significado',
  'accessibility.section3.item3': 'Navegación funcional con teclado en los formularios y flujos principales',
  'accessibility.section3.item4': 'Contraste de color pensado para facilitar la lectura, incluso para niños',
  'accessibility.section3.item5': 'Cambio de idioma completo entre español e inglés en toda la aplicación',
  'accessibility.section3.item6': 'Tipografía clara y tamaños de texto legibles, con diseño adaptable a celular, tablet y computadora',
  'accessibility.section4.title': '4. Limitaciones Conocidas',
  'accessibility.section4.text': 'Algunas partes de la plataforma todavía no cumplen completamente con WCAG 2.1 AA: ciertos minijuegos con arrastrar-y-soltar pueden ser difíciles de usar solo con teclado o lector de pantalla, y algunos componentes de terceros (como el proceso de pago y la sesión de voz en vivo) tienen su propio nivel de accesibilidad que no controlamos directamente. Seguimos trabajando para mejorar estos puntos.',
  'accessibility.section5.title': '5. Tecnología Compatible',
  'accessibility.section5.text': 'TutorIA Kids está diseñado para funcionar en las versiones recientes de los navegadores más comunes (Chrome, Safari, Edge y Firefox) en celular, tablet y computadora. Aunque no hemos probado exhaustivamente todas las combinaciones de lector de pantalla y navegador, seguimos las prácticas estándar de HTML semántico para maximizar la compatibilidad.',
  'accessibility.section6.title': '6. Cómo Reportar un Problema',
  'accessibility.section6.text': 'Si encuentras una barrera de accesibilidad al usar TutorIA Kids, o tienes una sugerencia, por favor escríbenos. Nos tomamos en serio cada reporte y trabajamos para resolverlo lo antes posible.',
  'accessibility.contact.title': '¿Encontraste una barrera de accesibilidad?',
  'accessibility.contact.text': 'Cuéntanos qué encontraste y en qué página, para que podamos revisarlo y mejorarlo.',

  // Cookies
  'cookies.title': '¡Usamos cookies!',
  'cookies.description': 'Utilizamos cookies para mejorar tu experiencia, analizar el uso de nuestra plataforma y mostrarte contenido que te encante.',
  'cookies.accept': 'Aceptar todo',
  'cookies.decline': 'Solo necesarias',
  'cookies.moreInfo': 'Más información',

  // Kids Dashboard Page
  'kidsDashboard.loadingAdventure': 'Cargando tu aventura...',
  'kidsDashboard.noStudentFound': 'Estudiante no encontrado',
  'kidsDashboard.noStudentMessage': '¡Pídele a tu papá o mamá que te agregue como estudiante primero!',
  'kidsDashboard.goToParentDashboard': 'Ir al Panel de Padres',
  'kidsDashboard.dailyStreak': 'Racha Diaria',
  'kidsDashboard.days': '{{count}} Días',
  'kidsDashboard.currentLevel': 'Nivel Actual',
  'kidsDashboard.level': 'Nivel {{level}}',
  'kidsDashboard.welcomeBack': '¡Bienvenido de nuevo, {{name}}! 👋',
  'kidsDashboard.readyForAdventure': '¿Listo para tu próxima aventura?',
  'kidsDashboard.xpProgress': '{{xp}} / 500 XP',
  'kidsDashboard.xpToNextLevel': '¡{{xp}} XP para el siguiente nivel!',
  'kidsDashboard.continueAdventure': 'Continúa Tu Aventura',
  'kidsDashboard.continueAdventureSubtitle': '¡Vuelve a aprender y gana más recompensas!',
  'kidsDashboard.startNextMission': 'Comenzar Siguiente Misión',
  'kidsDashboard.questIslands': 'Tus Islas de Aventura',
  'kidsDashboard.levelExplorer': 'Explorador Nivel {{level}}',
  'kidsDashboard.xp': 'XP',
  'kidsDashboard.pointsToNextLevel': '{{points}} puntos para el siguiente nivel',
  'kidsDashboard.myBadges': 'Mis Insignias',
  'kidsDashboard.locked': '🔒 Bloqueado',
  'kidsDashboard.playGames': 'Jugar',
  'kidsDashboard.miniMissAnnTitle': '¡Habla con Mini Miss Ann! 🎀',
  'kidsDashboard.miniMissAnnSubtitle': 'Practica letras, números y más, ¡solo hablando!',

  // Chat Page
  'chat.confirmEndSession': '¿Estás seguro de que quieres terminar esta sesión?',
  'chat.errorSavingSession': 'Error al guardar la sesión: {{message}}',
  'chat.fileTooLarge': 'El archivo es demasiado grande (máx. 5MB)',
  'chat.voiceNotSupported': 'La entrada de voz no es compatible.',
  'chat.micPermissionDenied': 'Necesitamos acceso al micrófono para escucharte. Por favor actívalo en la configuración de tu navegador.',
  'chat.voiceRecognitionError': 'No pudimos escucharte bien. Intenta de nuevo o escribe tu mensaje.',
  'chat.couldNotStartSession': 'No se pudo iniciar la sesión de chat. Verifica tus límites o tu conexión.',
  'chat.backToDashboard': 'Volver al Panel',
  'chat.online': 'En línea',
  'chat.endSession': 'Terminar Sesión',
  'chat.end': 'Terminar',
  'chat.greeting': '¡Hola {{name}}! 👋',
  'chat.introPrefix': 'Soy',
  'chat.introQuestion': '¿Qué tarea o pregunta resolvemos hoy?',
  'chat.sentImage': '📸 Envié una imagen',
  'chat.imageAttached': 'Imagen adjunta',
  'chat.uploadHomeworkPhoto': 'Subir Foto de Tarea',
  'chat.inputPlaceholder': 'Escribe o usa el micrófono...',
  'chat.stopListening': 'Detener Escucha',
  'chat.startVoiceInput': 'Iniciar Entrada de Voz',
  'chat.aiDisclaimer': 'La IA puede cometer errores. Verifica la información importante.',
  'chat.limitReachedTitle': '¡Límite alcanzado!',
  'chat.limitReachedMessage': 'Has completado todas tus sesiones disponibles para este periodo. ¡Tu hijo está aprendiendo muchísimo! ✨',
  'chat.upgradePlan': 'Mejorar mi Plan',
  'chat.altAi': 'IA',
  'chat.altUserUpload': 'Imagen del Usuario',
  'chat.altTyping': 'Escribiendo',
  'chat.altPreview': 'Vista Previa',

  // Agent Selection Page
  'agentSelection.title': '¡Conoce a tus Tutores! 🚀',
  'agentSelection.subtitle': 'Elige un tutor de IA especializado para ayudarte con tu tarea hoy. ¡Todos tienen superpoderes diferentes!',
  'agentSelection.startChat': 'Iniciar Chat',

  // Notification Center
  'notifications.title': 'Notificaciones',
  'notifications.markAllRead': 'Marcar todas como leídas',
  'notifications.empty': 'No tienes notificaciones',
  'notifications.deleteTooltip': 'Eliminar notificación',
  'notifications.achievementUnlocked': '¡Nuevo logro desbloqueado!',
  'notifications.timeAgo.now': 'Hace un momento',
  'notifications.timeAgo.minutes': 'Hace {{count}} min',
  'notifications.timeAgo.hours': 'Hace {{count}} h',
  'notifications.timeAgo.days': 'Hace {{count}} días',
  'notifications.toastTitle': '🎉 ¡Logro Desbloqueado!',
  'notifications.toastSubtitle': 'Revisa tus notificaciones',

  // Dashboard Page - Accesos Rápidos y Modal Editar Estudiante (batch 2 i18n)
  'dashboard.loadingDashboard': 'Cargando dashboard...',
  'dashboard.studentLimitReached': 'Has alcanzado el límite de {{limit}} estudiantes para tu plan. Por favor, actualiza tu plan para agregar más.',
  'dashboard.quickAccess.kidsDashboard': 'Panel Infantil',
  'dashboard.quickAccess.profile': 'Perfil',
  'dashboard.quickAccess.calendar': 'Calendario',

  // Calendario (/calendario) -- la pagina antes usaba t('Calendar'), t('Sunday')... como si
  // fueran claves reales; ninguna de esas existia en el diccionario, asi que siempre se veian
  // en ingles crudo sin importar el idioma activo. El resto del texto ni siquiera pasaba por t().
  'calendar.pageTitle': 'Calendario',
  'calendar.weekdays.sunday': 'Domingo',
  'calendar.weekdays.monday': 'Lunes',
  'calendar.weekdays.tuesday': 'Martes',
  'calendar.weekdays.wednesday': 'Miércoles',
  'calendar.weekdays.thursday': 'Jueves',
  'calendar.weekdays.friday': 'Viernes',
  'calendar.weekdays.saturday': 'Sábado',
  'calendar.loading': 'Cargando calendario...',
  'calendar.noSessions': 'No hay sesiones programadas para este día',
  'calendar.mustLogin': 'Debes iniciar sesión',
  'calendar.errorGettingStudent': 'No se pudo determinar el estudiante',
  'calendar.sessionAdded': 'Sesión agregada exitosamente',
  'calendar.sessionAddedWithEmail': 'Sesión agregada exitosamente. Se envió una notificación por correo.',
  'calendar.errorAdding': 'Error al agregar la sesión',
  'calendar.confirmDelete': '¿Estás seguro de que quieres eliminar esta sesión?',
  'calendar.sessionDeleted': 'Sesión eliminada',
  'calendar.errorDeleting': 'Error al eliminar la sesión',
  'calendar.completed': 'Completado',
  'calendar.sessionsFor': 'Sesiones del {{date}}',
  'calendar.addSession': 'Agregar Sesión',
  'calendar.add': 'Agregar',
  'calendar.noTimeSet': 'Sin hora',
  'calendar.durationMinutes': '{{count}} minutos',
  'calendar.startTutoringNow': 'Iniciar Tutoría Ahora',
  'calendar.startTutoring': 'Iniciar Tutoría',
  'calendar.newSessionModalTitle': 'Nueva Sesión',
  'calendar.subjectLabel': 'Materia',
  'calendar.subjectPlaceholder': 'Ej. Matemáticas, Ciencias, Historia',
  'calendar.dateTimeLabel': 'Fecha y Hora',
  'calendar.durationLabel': 'Duración (minutos)',
  'calendar.notesLabel': 'Notas',
  'calendar.notesPlaceholder': 'Notas adicionales...',
  'calendar.sending': 'Enviando...',
  'dashboard.quickAccess.achievements': 'Logros e Insignias',
  'dashboard.quickAccess.liveSession': 'Sesión en Vivo',
  'dashboard.recentActivity.practiceExam': 'Examen de Práctica',
  'dashboard.recentActivity.untitledHomework': 'Tarea sin título',
  'dashboard.recentActivity.noDetails': 'Sin detalles',
  'dashboard.recentActivity.studentFallback': 'Estudiante',
  'dashboard.recentActivity.durationMinutes': 'Duración: {{minutes}} minutos',
  'dashboard.recentActivity.gamePlayed': '🎮 Jugó un juego educativo',
  'dashboard.recentActivity.activityCompleted': 'Actividad completada',
  'dashboard.recentActivity.tutoringSession': 'Sesión de Tutoría',
  'dashboard.viewFullReport': 'Ver reporte completo',
  'dashboard.recentActivity.achievementUnlockedFallback': 'Logro Desbloqueado',
  'dashboard.recentActivity.dateUnavailable': 'Fecha no disponible',
  'dashboard.recentActivity.justNow': 'Justo ahora',
  'dashboard.recentActivity.minutesAgo': 'hace {{count}}m',
  'dashboard.recentActivity.hoursAgo': 'hace {{count}}h',
  'dashboard.recentActivity.daysAgo': 'hace {{count}}d',
  'dashboard.editStudentModal.title': 'Editar Estudiante',
  'dashboard.editStudentModal.updateInfo': 'Actualiza la información del estudiante según sea necesario',
  'dashboard.editStudentModal.namePlaceholder': 'Ej: María González',
  'dashboard.editStudentModal.ageHelp': 'Entre 3 y 18 años',
  'dashboard.editStudentModal.ageRangeError': 'La edad debe estar entre 3 y 18 años',
  'dashboard.editStudentModal.updateSuccess': '✅ Información del estudiante actualizada exitosamente',
  'dashboard.editStudentModal.updateError': 'Error al actualizar la información del estudiante',
  'dashboard.editStudentModal.gradeOptions.grade1': '1° Primaria',
  'dashboard.editStudentModal.gradeOptions.grade2': '2° Primaria',
  'dashboard.editStudentModal.gradeOptions.grade3': '3° Primaria',
  'dashboard.editStudentModal.gradeOptions.grade4': '4° Primaria',
  'dashboard.editStudentModal.gradeOptions.grade5': '5° Primaria',
  'dashboard.editStudentModal.gradeOptions.grade6': '6° Primaria',
  'dashboard.editStudentModal.gradeOptions.grade7': '1° Secundaria',
  'dashboard.editStudentModal.gradeOptions.grade8': '2° Secundaria',
  'dashboard.editStudentModal.gradeOptions.grade9': '3° Secundaria',
  'dashboard.editStudentModal.gradeOptions.grade10': '1° Preparatoria',
  'dashboard.editStudentModal.gradeOptions.grade11': '2° Preparatoria',
  'dashboard.editStudentModal.gradeOptions.grade12': '3° Preparatoria',

  // Reportes (batch 2 i18n)
  'reports.noSubject': 'Sin materia',
  'reports.title': 'Reportes',
  'reports.allStudents': 'Todos los Estudiantes',
  'reports.period': 'Período',
  'reports.lastWeek': 'Última Semana',
  'reports.lastMonth': 'Último Mes',
  'reports.allTime': 'Todo el Tiempo',
  'reports.sessionsTotalTime': '{{time}} en total',
  'reports.completionRate': 'Tasa de Finalización',
  'reports.performanceByStudent': 'Rendimiento por Estudiante',
  'reports.noDataAvailable': 'No hay datos disponibles',
  'reports.activitiesCompleted': 'Actividades Completadas (Tareas + Sesiones)',
  'reports.analysisBySubject': 'Análisis por Materia',
  'reports.noSubjectData': 'No hay datos de materia',
  'reports.activitySummary': 'Resumen de Actividad',
  'reports.homeworkAssigned': 'Tareas Asignadas',
  'reports.studyTime': 'Tiempo de Estudio',
  'reports.studentLabel': 'Estudiante',
  'reports.totalHomeworkLabel': 'Tareas Totales',
  'reports.sessionsLabel': 'Sesiones',
  'reports.averageLabel': 'Promedio',
  'reports.achievementsLabel': 'Logros',
  'reports.aiTutoringLabel': 'Tutoría con IA',
  'subjects.mathematics': 'Matemáticas',
  'subjects.science': 'Ciencias',
  'subjects.socialStudies': 'Estudios Sociales',
  'subjects.languageArts': 'Lenguaje',
  'subjects.generalHelp': 'Ayuda General',
  'subjects.liveSession': 'Sesión en Vivo con Miss Ann',
  'subjects.liveSessionPrek': 'Sesión en Vivo con Mini Miss Ann',
  'subjects.general': 'General',
  'subjects.legacyGameActivity': 'Actividad de Juego',

  // Logros /logros (batch 2 i18n)
  'achievements.loading': 'Cargando logros...',
  'achievements.pageTitle': '🏆 Logros e Insignias',
  'achievements.subtitle': 'Tus logros y recompensas',
  'achievements.pointsCount': '{{points}} Puntos',
  'achievements.unlockedCount': 'Has desbloqueado {{count}} logros',
  'achievements.categories.all': 'Todos',
  'achievements.categories.study': 'Estudio',
  'achievements.categories.games': 'Juegos',
  'achievements.categories.streaks': 'Rachas',
  'achievements.categories.special': 'Especial',
  'achievements.noAchievementsYet': 'Aún no hay logros',
  'achievements.noAchievementsInCategory': 'No hay logros en esta categoría',
  'achievements.keepGoing': '¡Sigue estudiando y jugando para desbloquear logros increíbles!',
  'achievements.pointsBadge': '+{{points}} pts',
  'achievements.items.firstSession.title': '🚀 Primera Sesión',
  'achievements.items.firstSession.description': 'Completaste tu primera sesión de tutoría',
  'achievements.items.sessionMaster.title': '🧙‍♂️ Mago del Conocimiento',
  'achievements.items.sessionMaster.description': 'Completaste 5 sesiones de tutoría',
  'achievements.items.sessionLegend.title': '🏆 Leyenda del Estudio',
  'achievements.items.sessionLegend.description': 'Completaste 20 sesiones de tutoría',
  'achievements.items.homeworkStarter.title': '📝 Primeros Pasos',
  'achievements.items.homeworkStarter.description': 'Subiste tu primera tarea',
  'achievements.items.homeworkPro.title': '📚 Experto en Tareas',
  'achievements.items.homeworkPro.description': 'Completaste 10 tareas',
  'achievements.items.gamePlayer.title': '🎮 Jugador Novato',
  'achievements.items.gamePlayer.description': 'Jugaste tu primer juego educativo',
  'achievements.items.gameMaster.title': '🎯 Maestro de Juegos',
  'achievements.items.gameMaster.description': 'Jugaste 10 juegos educativos',
  'achievements.items.streak3.title': '🔥 En Racha',
  'achievements.items.streak3.description': 'Estudiaste 3 días seguidos',
  'achievements.items.streak7.title': '⚡ Imparable',
  'achievements.items.streak7.description': 'Estudiaste 7 días seguidos',

  // Exámenes de Práctica /simulacros (batch 2 i18n)
  'practiceTests.title': 'Exámenes de Práctica',
  'practiceTests.subtitle': 'Practica con exámenes generados por IA',
  'practiceTests.back': '← Volver',
  'practiceTests.selectStudentAndGrade': 'Por favor selecciona un estudiante y un grado',
  'practiceTests.generateError': 'No se pudo generar el examen de práctica. Inténtalo de nuevo.',
  'practiceTests.confirmUnanswered': 'Tienes {{count}} preguntas sin responder. ¿Deseas enviarlo de todas formas?',
  'practiceTests.evaluateError': 'No se pudo evaluar el examen. Inténtalo de nuevo.',
  'practiceTests.examCompleted': '¡Examen Completado!',
  'practiceTests.greatJob': '¡Buen trabajo, {{name}}!',
  'practiceTests.score': 'Puntuación',
  'practiceTests.correctAnswers': 'Respuestas correctas',
  'practiceTests.difficultyLevel': 'Nivel de Dificultad',
  'practiceTests.detailedResults': 'Resultados Detallados',
  'practiceTests.explanation': 'Explicación:',
  'practiceTests.newPracticeTest': 'Nuevo Examen de Práctica',
  'practiceTests.questionsLabel': 'Preguntas',
  'practiceTests.previous': '← Anterior',
  'practiceTests.evaluating': 'Evaluando...',
  'practiceTests.submitExam': 'Enviar Examen',
  'practiceTests.next': 'Siguiente →',
  'practiceTests.configureExam': 'Configurar Examen',
  'practiceTests.selectStudentOption': 'Selecciona un estudiante...',
  'practiceTests.gradeLevel': 'Nivel de Grado',
  'practiceTests.selectGradeLevelOption': 'Selecciona el nivel de grado...',
  'practiceTests.grades.kindergarten': 'Kínder',
  'practiceTests.schoolQuarter': 'Trimestre Escolar',
  'practiceTests.quarters.q1Period': 'Ago - Oct',
  'practiceTests.quarters.q2Period': 'Oct - Dic',
  'practiceTests.quarters.q3Period': 'Ene - Mar',
  'practiceTests.quarters.q4Period': 'Mar - May',
  'practiceTests.subject': 'Materia',
  'practiceTests.subjects.mathematics': 'Matemáticas',
  'practiceTests.subjects.science': 'Ciencias',
  'practiceTests.subjects.spanish': 'Español',
  'practiceTests.subjects.english': 'Inglés',
  'practiceTests.subjects.socialStudies': 'Estudios Sociales',
  'practiceTests.subjects.history': 'Historia',
  'practiceTests.numberOfQuestions': 'Número de Preguntas: {{count}}',
  'practiceTests.difficulty.basic': 'Básico',
  'practiceTests.difficulty.intermediate': 'Interm',
  'practiceTests.difficulty.advanced': 'Avan',
  'practiceTests.generatingExam': 'Generando examen...',
  'practiceTests.startPracticeTest': 'Comenzar Examen de Práctica',
  'practiceTests.benefits.title': 'Beneficios',
  'practiceTests.benefits.item1': 'Preguntas generadas por IA',
  'practiceTests.benefits.item2': 'Alineado con el currículo escolar',
  'practiceTests.benefits.item3': 'Retroalimentación instantánea',
  'practiceTests.benefits.item4': 'Explicaciones detalladas',
  'practiceTests.quarterSystem.title': 'Sistema de Trimestres',
  'practiceTests.quarterSystem.description': 'Selecciona el trimestre escolar para generar preguntas alineadas con el período curricular actual.',
  'practiceTests.statistics.title': 'Estadísticas',
  'practiceTests.statistics.testsCompleted': 'Exámenes completados',
  'practiceTests.statistics.averageScore': 'Puntuación promedio',
  'practiceTests.tips.title': 'Consejos',
  'practiceTests.tips.item1': 'Lee cada pregunta con atención',
  'practiceTests.tips.item2': 'Tómate tu tiempo',
  'practiceTests.tips.item3': 'Revisa tus respuestas',

  // Detalle de Estudiante /estudiante (batch 2 i18n)
  'studentDetail.notFound': 'Estudiante no encontrado',
  'studentDetail.backToDashboard': 'Volver al Dashboard',
  'studentDetail.navDashboard': 'Panel',
  'studentDetail.stats.completedHomework': 'Tareas Completadas',
  'studentDetail.stats.studyHours': 'Horas de Estudio',
  'studentDetail.stats.average': 'Promedio',
  'studentDetail.tabs.summary': 'Resumen',
  'studentDetail.tabs.sessions': 'Sesiones ({{count}})',
  'studentDetail.tabs.achievements': 'Logros ({{count}})',
  'studentDetail.tabs.homework': 'Tareas ({{count}})',
  'studentDetail.noSessionsYet': 'Aún no hay sesiones registradas',
  'studentDetail.sessionsMinutes': '{{sessions}} sesiones · {{minutes}} min',
  'studentDetail.noActivityRecorded': 'No hay actividad registrada',
  'studentDetail.sessionOf': 'Sesión de {{subject}}',
  'studentDetail.minutesCompleted': '{{minutes}} minutos · {{percent}}% completado',
  'studentDetail.homeworkPrefix': 'Tarea: {{title}}',
  'studentDetail.homeworkCompleted': 'Completada',
  'studentDetail.homeworkPending': 'Pendiente',
  'studentDetail.sessionHistory': 'Historial de Sesiones',
  'studentDetail.startFirstSession': 'Iniciar Primera Sesión',
  'studentDetail.completedLabel': 'Completado',
  'studentDetail.minutesLabel': 'Minutos',
  'studentDetail.questionsLabel': 'Preguntas',
  'studentDetail.hintsLabel': 'Pistas',
  'studentDetail.aiFeedback': 'Retroalimentación de IA',
  'studentDetail.unlockedAchievements': 'Logros Desbloqueados',
  'studentDetail.noAchievementsUnlocked': 'Aún no hay logros desbloqueados',
  'studentDetail.studentHomeworkTitle': 'Tareas del Estudiante',
  'studentDetail.noHomeworkRecorded': 'No hay tareas registradas',
  'studentDetail.uploadHomework': 'Subir Tarea',
  'studentDetail.aiAnalysis': 'Análisis de IA',
  'studentDetail.overallSummary': 'Resumen General',
  'studentDetail.totalStudyTime': 'Tiempo total de estudio',
  'studentDetail.averageCompletion': 'Finalización promedio',
  'simulacros.selectStudentAndGrade': 'Por favor selecciona un estudiante y un nivel de grado',
  'simulacros.studentNotFound': 'Estudiante no encontrado',
  'simulacros.errorGenerating': 'Error al generar el examen de práctica',
  'simulacros.noQuestionsReceived': 'No se recibieron preguntas',
  'simulacros.couldNotGenerate': 'No se pudo generar el examen de práctica. Inténtalo de nuevo.',
  'simulacros.unansweredConfirm': 'Tienes {{count}} preguntas sin responder. ¿Quieres enviarlo de todas formas?',
  'simulacros.errorEvaluating': 'Error al evaluar el examen',
  'simulacros.couldNotEvaluate': 'No se pudo evaluar el examen. Inténtalo de nuevo.',
  'simulacros.examCompleted': '¡Examen Completado!',
  'simulacros.greatJob': '¡Buen trabajo, {{name}}!',
  'simulacros.score': 'Puntaje',
  'simulacros.correctAnswers': 'Respuestas correctas',
  'simulacros.difficultyLevel': 'Nivel de Dificultad',
  'simulacros.detailedResults': 'Resultados Detallados',
  'simulacros.explanation': 'Explicación:',
  'simulacros.newPracticeTest': 'Nuevo Examen de Práctica',
  'simulacros.questionsCount': 'Preguntas',
  'simulacros.previous': '← Anterior',
  'simulacros.next': 'Siguiente →',
  'simulacros.evaluating': 'Evaluando...',
  'simulacros.submitExam': 'Enviar Examen',
  'simulacros.subtitle': 'Practica con exámenes generados por IA',
  'simulacros.configureExam': 'Configurar Examen',
  'simulacros.selectStudent': 'Selecciona un Estudiante',
  'simulacros.selectStudentPlaceholder': 'Selecciona un estudiante...',
  'simulacros.gradeLevel': 'Nivel de Grado',
  'simulacros.selectGradePlaceholder': 'Selecciona el nivel de grado...',
  'simulacros.grades.preschool': 'Preescolar',
  'simulacros.grades.grade1': '1° Grado',
  'simulacros.grades.grade2': '2° Grado',
  'simulacros.grades.grade3': '3° Grado',
  'simulacros.grades.grade4': '4° Grado',
  'simulacros.grades.grade5': '5° Grado',
  'simulacros.grades.grade6': '6° Grado',
  'simulacros.grades.grade7': '7° Grado',
  'simulacros.grades.grade8': '8° Grado',
  'simulacros.grades.grade9': '9° Grado',
  'simulacros.grades.grade10': '10° Grado',
  'simulacros.grades.grade11': '11° Grado',
  'simulacros.grades.grade12': '12° Grado',
  'simulacros.schoolQuarter': 'Trimestre Escolar',
  'simulacros.quarters.q1Period': 'Ago - Oct',
  'simulacros.quarters.q2Period': 'Nov - Dic',
  'simulacros.quarters.q3Period': 'Ene - Mar',
  'simulacros.quarters.q4Period': 'Abr - Jun',
  'simulacros.subject': 'Materia',
  'simulacros.subjects.mathematics': 'Matemáticas',
  'simulacros.subjects.science': 'Ciencias',
  'simulacros.subjects.spanish': 'Español',
  'simulacros.subjects.english': 'Inglés',
  'simulacros.subjects.socialStudies': 'Estudios Sociales',
  'simulacros.subjects.history': 'Historia',
  'simulacros.numberOfQuestions': 'Número de Preguntas: {{count}}',
  'simulacros.difficulty.basic': 'Básico',
  'simulacros.difficulty.intermediate': 'Inter',
  'simulacros.difficulty.advanced': 'Avan',
  'simulacros.generatingExam': 'Generando examen...',
  'simulacros.startPracticeTest': 'Iniciar Examen de Práctica',
  'simulacros.benefits': 'Beneficios',
  'simulacros.benefit1': 'Preguntas generadas por IA',
  'simulacros.benefit2': 'Alineado con el currículo escolar',
  'simulacros.benefit3': 'Retroalimentación instantánea',
  'simulacros.benefit4': 'Explicaciones detalladas',
  'simulacros.quarterSystem': 'Sistema de Trimestres',
  'simulacros.quarterSystemDesc': 'Selecciona el trimestre escolar para generar preguntas alineadas con el período curricular actual.',
  'simulacros.statistics': 'Estadísticas',
  'simulacros.testsCompleted': 'Exámenes completados',
  'simulacros.averageScore': 'Puntaje promedio',
  'simulacros.tips': 'Consejos',
  'simulacros.tip1': 'Lee cada pregunta con atención',
  'simulacros.tip2': 'Tómate tu tiempo',
  'simulacros.tip3': 'Revisa tus respuestas',

  // Games Intro/Selection Screens (i18n coverage batch 3)
  'games.selectStudentAlert': 'Por favor selecciona un estudiante en el Dashboard antes de jugar.',
  'games.noActiveStudentAlert': '⚠️ Error: No se detectó ningún estudiante activo. Regresa al Dashboard para seleccionar uno.',
  'games.listenAgain': 'Escuchar de nuevo',

  // Modulo Pre-K/1er Grado: Sonidos de Letras (conciencia fonologica, sin necesidad de leer)
  'games.letterSounds.title': 'Sonidos de Letras',
  'games.letterSounds.subtitle': 'Escucha el sonido y toca la imagen correcta',
  'games.letterSounds.howToPlay': '¿Cómo se juega?',
  'games.letterSounds.step1': 'Escucha',
  'games.letterSounds.step1Desc': 'Presta atención al sonido que escuchas',
  'games.letterSounds.step2': 'Toca',
  'games.letterSounds.step2Desc': 'Elige la imagen que empieza con ese sonido',
  'games.letterSounds.step3': 'Celebra',
  'games.letterSounds.step3Desc': '¡Gana puntos y sigue aprendiendo!',
  'games.letterSounds.startGame': 'Comenzar a Jugar',
  'games.letterSounds.promptAudio': '¿Qué imagen empieza con el sonido {{sound}}?',
  'games.letterSounds.question': '¿Cuál empieza con este sonido?',
  'games.letterSounds.correctCelebration': '¡Muy bien hecho!',

  // Modulo Pre-K/1er Grado: Contando Divertido (conteo, sin necesidad de leer)
  'games.counting.title': 'Contando Divertido',
  'games.counting.subtitle': 'Escucha el número y toca el grupo correcto',
  'games.counting.step1': 'Escucha',
  'games.counting.step1Desc': 'Presta atención al número que escuchas',
  'games.counting.step2': 'Cuenta',
  'games.counting.step2Desc': 'Toca el grupo que tiene esa cantidad',
  'games.counting.step3': 'Celebra',
  'games.counting.step3Desc': '¡Gana puntos y sigue contando!',
  'games.counting.promptAudio': 'Toca el grupo que tiene {{count}} {{object}}',
  'games.counting.question': '¿Dónde hay {{count}} {{object}}?',
  'games.counting.correctCelebration': '¡Correcto! Son {{count}}. ¡Muy bien contado!',
  'games.counting.wrongFeedback': 'La respuesta correcta era {{count}}. ¡Vamos a intentarlo de nuevo!',

  // Emoji Zoo Game - Intro Screen
  'games.zoo.startGame': 'Comenzar Juego',
  'games.zoo.selectDifficultyFirst': 'Selecciona una dificultad primero',
  'games.zoo.whatWillYouLearn': '¿Qué aprenderás?',
  'games.zoo.alphabetRecognition': 'Reconocimiento del Alfabeto',
  'games.zoo.alphabetRecognitionDesc': 'Aprende todas las letras de forma divertida',
  'games.zoo.visualMemory': 'Memoria Visual',
  'games.zoo.visualMemoryDesc': 'Mejora tu memoria con los animales',
  'games.zoo.handEyeCoordination': 'Coordinación Ojo-Mano',
  'games.zoo.handEyeCoordinationDesc': 'Desarrolla habilidades motoras',
  'games.zoo.vocabulary': 'Vocabulario',
  'games.zoo.vocabularyDesc': 'Aprende nuevas palabras en inglés',

  // Math Games - Intro Screen
  'games.math.pageTitle': '🔢 Juegos de Matemáticas',
  'games.math.pageSubtitle': 'Elige tu aventura matemática favorita',
  'games.math.bannerTitle': '4 Formas Diferentes de Aprender',
  'games.math.bannerDesc': 'Cada juego tiene un estilo único para que practiques matemáticas de forma divertida. Elige el que más te guste o pruébalos todos para dominar los números.',
  'games.math.levelLabel': 'Nivel:',
  'games.math.featuresLabel': 'Características:',
  'games.math.tipsTitle': '💡 Consejos para Mejorar',
  'games.math.tip1Title': 'Practica a diario',
  'games.math.tip1Desc': '10-15 minutos al día mejoran tu velocidad mental',
  'games.math.tip2Title': 'Establece metas',
  'games.math.tip2Desc': 'Intenta superar tu récord personal cada día',
  'games.math.tip3Title': 'Aprende de tus errores',
  'games.math.tip3Desc': 'Revisa las explicaciones cuando falles',
  'games.math.tip4Title': 'Varía los juegos',
  'games.math.tip4Desc': 'Cada juego desarrolla habilidades diferentes',
  'games.math.games.desafioRapido.name': 'Desafío Matemático Rápido',
  'games.math.games.desafioRapido.description': 'Resuelve problemas contra el reloj y mejora tu velocidad mental',
  'games.math.games.desafioRapido.feature1': 'Tiempo límite por problema',
  'games.math.games.desafioRapido.feature2': 'Operaciones múltiples',
  'games.math.games.desafioRapido.feature3': 'Puntos por velocidad',
  'games.math.games.desafioRapido.feature4': 'Niveles de dificultad',
  'games.math.games.desafioRapido.difficulty': 'Todos los niveles',
  'games.math.games.aventura.name': 'Aventura Matemática',
  'games.math.games.aventura.description': 'Ayuda al explorador a encontrar el tesoro resolviendo problemas',
  'games.math.games.aventura.feature1': 'Historia interactiva',
  'games.math.games.aventura.feature2': 'Misiones y personajes',
  'games.math.games.aventura.feature3': 'Problemas contextualizados',
  'games.math.games.aventura.feature4': 'Recompensas especiales',
  'games.math.games.aventura.difficulty': 'Kínder - 6to grado',
  'games.math.games.dueloNumeros.name': 'Duelo de Números',
  'games.math.games.dueloNumeros.description': 'Compite contra el tiempo en una racha de problemas progresivos',
  'games.math.games.dueloNumeros.feature1': 'Dificultad progresiva',
  'games.math.games.dueloNumeros.feature2': 'Sistema de rachas',
  'games.math.games.dueloNumeros.feature3': 'Tabla de récords',
  'games.math.games.dueloNumeros.feature4': 'Desafíos diarios',
  'games.math.games.dueloNumeros.difficulty': '3ro - 6to grado',
  'games.math.games.memoryMatch.name': 'Memorama Matemático',
  'games.math.games.memoryMatch.description': 'Encuentra pares de problemas matemáticos y sus respuestas',
  'games.math.games.memoryMatch.feature1': 'Juego de memoria clásico',
  'games.math.games.memoryMatch.feature2': 'Empareja problemas con respuestas',
  'games.math.games.memoryMatch.feature3': 'Múltiples niveles de grado',
  'games.math.games.memoryMatch.feature4': 'Mejora el cálculo mental',
  'games.math.games.memoryMatch.difficulty': 'Kínder - 3er grado',

  // Geo Mystery - Intro Screen
  'games.geoMystery.pageTitle': '🌍 ¿Dónde en el mundo está...?',
  'games.geoMystery.pageSubtitle': 'Descubre países misteriosos con pistas de la IA',
  'games.geoMystery.howToPlay': '¿Cómo jugar?',
  'games.geoMystery.rule1': 'La IA se "esconde" en un país del mundo',
  'games.geoMystery.rule2': 'Recibirás pistas progresivas sobre el país',
  'games.geoMystery.rule3': 'Adivina con menos pistas para ganar más puntos',
  'games.geoMystery.rule4': 'Aprende geografía de forma divertida',
  'games.geoMystery.rule5': 'Descubre datos fascinantes sobre cada país',
  'games.geoMystery.difficulties.easy.name': 'Fácil',
  'games.geoMystery.difficulties.easy.description': 'Países famosos con 5 pistas',
  'games.geoMystery.difficulties.medium.name': 'Medio',
  'games.geoMystery.difficulties.medium.description': 'Varios países con 4 pistas',
  'games.geoMystery.difficulties.hard.name': 'Difícil',
  'games.geoMystery.difficulties.hard.description': 'Países desafiantes con 3 pistas',
  'games.geoMystery.numberOfClues': 'Número de pistas:',
  'games.geoMystery.pointsSystem': 'Sistema de puntos:',
  'games.geoMystery.clueLabel': 'Pista {{number}}:',
  'games.geoMystery.pts': 'pts',
  'games.geoMystery.tipEasy': 'Perfecto para empezar. Países muy conocidos con muchas pistas.',
  'games.geoMystery.tipMedium': 'Un desafío equilibrado. Países de todo el mundo.',
  'games.geoMystery.tipHard': '¡Para expertos! Países menos conocidos con pocas pistas.',
  'games.geoMystery.exampleTitle': 'Ejemplo de juego',
  'games.geoMystery.firstClue': 'Primera Pista:',
  'games.geoMystery.secondClue': 'Segunda Pista:',
  'games.geoMystery.thirdClue': 'Tercera Pista:',
  'games.geoMystery.exampleClue1': '"Estoy en un continente donde hay muchos canguros"',
  'games.geoMystery.exampleClue2': '"Mi bandera tiene estrellas y es azul, roja y blanca"',
  'games.geoMystery.exampleClue3': '"Tengo una famosa casa de ópera con forma de velas"',
  'games.geoMystery.exampleAnswer': '¡Respuesta: Australia! 🇦🇺',

  // Dr. AI - Intro Screen
  'games.drIA.pageTitle': '🩺 Diagnóstico del Dr. IA',
  'games.drIA.pageSubtitle': 'Aprende anatomía diagnosticando pacientes virtuales',
  'games.drIA.howToPlay': '¿Cómo Jugar?',
  'games.drIA.rule1': 'Un paciente virtual describe sus síntomas',
  'games.drIA.rule2': 'Analiza cuidadosamente los síntomas',
  'games.drIA.rule3': 'Elige qué sistema del cuerpo examinar',
  'games.drIA.rule4': 'Selecciona el diagnóstico correcto',
  'games.drIA.rule5': 'Aprende sobre anatomía y los sistemas del cuerpo',
  'games.drIA.systems.circulatory.title': 'Sistema Circulatorio',
  'games.drIA.systems.circulatory.description': 'Corazón, arterias, venas y sangre. Transporta oxígeno y nutrientes.',
  'games.drIA.systems.circulatory.symptoms': 'Dolor de pecho, palpitaciones, fatiga',
  'games.drIA.systems.circulatoryShort': 'Corazón y vasos sanguíneos',
  'games.drIA.systems.respiratory.title': 'Sistema Respiratorio',
  'games.drIA.systems.respiratory.description': 'Pulmones, tráquea y bronquios. Permite la respiración y la entrada de oxígeno.',
  'games.drIA.systems.respiratory.symptoms': 'Tos, dificultad para respirar, dolor de pecho',
  'games.drIA.systems.respiratoryShort': 'Pulmones y vías respiratorias',
  'games.drIA.systems.digestive.title': 'Sistema Digestivo',
  'games.drIA.systems.digestive.description': 'Estómago, intestinos e hígado. Procesa los alimentos y nutrientes.',
  'games.drIA.systems.digestive.symptoms': 'Dolor abdominal, náuseas, diarrea',
  'games.drIA.systems.digestiveShort': 'Estómago e intestinos',
  'games.drIA.systems.nervous.title': 'Sistema Nervioso',
  'games.drIA.systems.nervous.description': 'Cerebro, médula espinal y nervios. Controla las funciones del cuerpo y los sentidos.',
  'games.drIA.systems.nervous.symptoms': 'Dolores de cabeza, mareos, entumecimiento',
  'games.drIA.systems.nervousShort': 'Cerebro y nervios',
  'games.drIA.commonSymptomsLabel': 'Síntomas comunes:',
  'games.drIA.difficulties.easy.name': 'Principiante',
  'games.drIA.difficulties.easy.description': 'Casos simples con síntomas muy claros',
  'games.drIA.difficulties.medium.name': 'Doctor Junior',
  'games.drIA.difficulties.medium.description': 'Casos moderados con múltiples síntomas',
  'games.drIA.difficulties.hard.name': 'Especialista',
  'games.drIA.difficulties.hard.description': 'Casos complejos que requieren un análisis detallado',
  'games.drIA.casesToSolve': 'Casos a resolver:',
  'games.drIA.pointsPerCase': 'Puntos por caso:',
  'games.drIA.tipEasy': 'Perfecto para empezar. Síntomas muy claros y directos.',
  'games.drIA.tipMedium': 'Casos más complejos con múltiples síntomas.',
  'games.drIA.tipHard': '¡Para expertos! Requiere un análisis detallado.',
  'games.drIA.startDiagnosis': 'Iniciar Diagnóstico',
  'games.drIA.exampleTitle': 'Ejemplo de Caso Médico',
  'games.drIA.virtualPatientLabel': 'Paciente Virtual:',
  'games.drIA.examplePatientText': '"Hola doctor, me duele el pecho cuando corro y siento que me falta el aire. También noto que mi corazón late muy rápido."',
  'games.drIA.respiratorySelected': 'Sistema Respiratorio ✓',
  'games.drIA.correctDiagnosisLabel': 'Diagnóstico Correcto:',
  'games.drIA.exampleDiagnosis': 'Asma inducida por el ejercicio',
  'games.drIA.exampleDiagnosisSuffix': '- Problema del sistema respiratorio',
  'games.drIA.exampleExplanation': 'El asma causa inflamación en las vías respiratorias, dificultando la respiración durante el ejercicio. Los síntomas incluyen falta de aire, tos y opresión en el pecho.',

  // Secret Words - Intro Screen
  'games.secretWords.intro.title': '🔤 Desafío de Palabras Secretas',
  'games.secretWords.intro.subtitle': 'Adivina palabras educativas con pistas de la IA',
  'games.secretWords.intro.howToPlay': '¿Cómo jugar?',
  'games.secretWords.intro.rule1': 'Adivina la palabra oculta letra por letra',
  'games.secretWords.intro.rule2': 'Usa las pistas generadas por IA cuando las necesites',
  'games.secretWords.intro.rule3': 'Tienes 6 intentos antes de perder',
  'games.secretWords.intro.rule4': 'Gana 10 puntos por cada palabra correcta',
  'games.secretWords.intro.rule5': '¡Aprende vocabulario mientras te diviertes!',
  'games.secretWords.intro.configTitle': '⚙️ Configuración del Juego',
  'games.secretWords.intro.languageLabel': '🌐 Idioma del Juego',
  'games.secretWords.intro.gradeLabel': '🎓 Selecciona el Grado',
  'games.secretWords.intro.subjectLabel': '📚 Selecciona la Materia',
  'games.secretWords.intro.topicLabel': '🎯 Selecciona el Tema',
  'games.secretWords.intro.startButton': '🎮 ¡Comenzar a Jugar!',
  'games.secretWords.intro.completeConfig': '⚠️ Completa la configuración',
  'games.secretWords.intro.feature1Title': 'IA Dinámica',
  'games.secretWords.intro.feature1Desc': 'Las palabras y pistas son generadas en tiempo real por inteligencia artificial',
  'games.secretWords.intro.feature2Title': 'Pistas Inteligentes',
  'games.secretWords.intro.feature2Desc': 'Recibe pistas crípticas que te ayudan a pensar y aprender',
  'games.secretWords.intro.feature3Title': 'Bilingüe',
  'games.secretWords.intro.feature3Desc': 'Juega en español o inglés para practicar ambos idiomas',

  // Time Machine - Intro & Chat Screens
  'games.timeMachine.badge': 'Juego de Historia',
  'games.timeMachine.pageTitle': 'La Máquina del Tiempo',
  'games.timeMachine.pageSubtitle': 'Viaja al pasado y entrevista a personajes históricos',
  'games.timeMachine.howItWorks': '¿Cómo funciona?',
  'games.timeMachine.step1': 'Elige un personaje histórico famoso',
  'games.timeMachine.step2': 'Lee tu misión y las preguntas clave',
  'games.timeMachine.step3': 'Chatea con el personaje (la IA adopta su personalidad)',
  'games.timeMachine.step4': 'Haz las preguntas correctas para ganar puntos',
  'games.timeMachine.step5': 'Aprende historia de forma divertida',
  'games.timeMachine.missionLabel': 'Tu Misión:',
  'games.timeMachine.suggestedQuestionsLabel': 'Algunas preguntas sugeridas:',
  'games.timeMachine.moreQuestions': '...y 5 preguntas más por descubrir',
  'games.timeMachine.startAdventure': 'Comenzar Aventura',
  'games.timeMachine.chat.exit': '← Salir',
  'games.timeMachine.chat.points': 'Puntos',
  'games.timeMachine.chat.keyQuestions': 'Preguntas Clave',
  'games.timeMachine.chat.totalQuestions': 'Preguntas Totales',
  'games.timeMachine.chat.missionProgress': 'Progreso de la Misión',
  'games.timeMachine.chat.placeholder': 'Escribe tu pregunta aquí...',
  'games.timeMachine.chat.send': 'Enviar',
  'games.timeMachine.chat.suggestedQuestions': '💡 Preguntas Sugeridas (10 en total, 3 son clave y valen 10 puntos cada una):',
  'games.timeMachine.chat.foundProgress': '🎯 Has encontrado {{count}} de 3 preguntas clave. ¡Sigue explorando!',
  'games.timeMachine.chat.welcomeMessage': '¡Hola! Soy {{name}}, {{title}}. He viajado desde el año {{period}} para hablar contigo. Tu misión es: {{mission}} ¡Hazme preguntas y aprende sobre mi vida y mi época! Hay 3 preguntas clave secretas que te darán 10 puntos cada una. ¿Podrás descubrirlas?',
  'games.timeMachine.chat.bonusMessage': '🎉 ¡Excelente pregunta! Has descubierto una pregunta clave. Has ganado 10 puntos. ({{count}}/3 preguntas clave encontradas)',
  'games.timeMachine.chat.connectionError': 'Lo sentimos, hubo un problema al conectar con el personaje histórico. Verifica que la API de OpenAI esté configurada correctamente e inténtalo de nuevo.',

  // Geo Mystery - Pantalla de Juego
  'games.geoMystery.generatingCountries': 'Generando países misteriosos...',
  'games.geoMystery.preparingAdventure': 'Preparando tu aventura geográfica 🌍',
  'games.geoMystery.generateErrorAlert': 'Error al generar el juego. Por favor intenta de nuevo.',
  'games.geoMystery.roundLabel': 'Ronda {{current}} de {{total}}',
  'games.geoMystery.whatCountryAmI': '¿Qué país soy?',
  'games.geoMystery.useCluesSubtitle': 'Usa las pistas para descubrirlo',
  'games.geoMystery.availableCluesHeading': 'Pistas Disponibles',
  'games.geoMystery.cluesRevealedCount': '{{revealed}} / {{max}} reveladas',
  'games.geoMystery.revealNextClueButton': 'Revelar Siguiente Pista',
  'games.geoMystery.minusPtsSuffix': '(-{{points}} pts)',
  'games.geoMystery.yourAnswerHeading': 'Tu Respuesta',
  'games.geoMystery.countryInputPlaceholder': 'Escribe el nombre del país...',
  'games.geoMystery.checkingLabel': 'Verificando...',
  'games.geoMystery.checkAnswerButton': 'Verificar Respuesta',
  'games.geoMystery.pressEnterHint': 'Presiona Enter para enviar tu respuesta',
  'games.geoMystery.cluesUsedSingular': 'Usaste {{count}} pista',
  'games.geoMystery.cluesUsedPlural': 'Usaste {{count}} pistas',
  'games.geoMystery.correctFeedback': '🎉 ¡Correcto! ¡Es {{country}}!\n\n✨ {{cluesText}}\n🏆 +{{points}} puntos',
  'games.geoMystery.incorrectFeedback': '❌ Incorrecto. ¡Intenta de nuevo!\n\n💡 Consejo: Revela más pistas si necesitas ayuda',
  'games.geoMystery.gameCompleteTitle': '¡Juego Completado!',
  'games.geoMystery.gameCompleteSubtitle': '¡Excelente trabajo explorando el mundo!',
  'games.geoMystery.accuracyLabel': 'Precisión',
  'games.geoMystery.performanceHeading': 'Desempeño',
  'games.geoMystery.perfectMessage': '¡Perfecto! ¡Eres un maestro de la geografía!',
  'games.geoMystery.excellentMessage': '¡Excelente! ¡Conoces muy bien el mundo!',
  'games.geoMystery.goodJobMessage': '¡Buen trabajo! ¡Sigue explorando!',
  'games.geoMystery.keepPracticingMessage': '¡Sigue practicando! Cada juego te hace mejor!',
  'games.geoMystery.backToMenuButton': '🏠 Volver al Menú',

  // Juegos de Matemáticas - Textos compartidos de juego (Aventura Matemática, Desafío Rápido, Duelo de Números, Memorama)
  'games.math.exitGame': 'Salir del Juego',
  'games.math.backToMenu': 'Volver al Menú',
  'games.math.checkAnswer': 'Verificar Respuesta',
  'games.math.answerPlaceholder': 'Tu respuesta',
  'games.math.incorrectTryAgain': 'Incorrecto, intenta de nuevo',
  'games.math.playAgain': '🔄 Jugar de Nuevo',
  'games.math.pointsColon': 'Puntos:',
  'games.math.pointsLabel': 'Puntos',
  'games.math.solvedLabel': 'Resueltos',
  'games.math.streakLabel': 'Racha',
  'games.math.timeLabel': 'Tiempo',
  'games.math.livesLabel': 'Vidas',
  'games.math.livesColon': 'Vidas:',
  'games.math.problemsSolvedLabel': 'Problemas Resueltos',
  'games.math.bestStreakLabel': 'Mejor Racha',
  'games.math.problemNumberLabel': 'Problema #{{number}}',
  'games.math.secondsLabel': 'segundos',
  'games.math.streakOf': 'Racha de {{count}}',
  'games.math.extraPointsSuffix': '(+{{points}} puntos extra)',
  'games.math.operations.addition': 'Suma',
  'games.math.operations.subtraction': 'Resta',
  'games.math.operations.multiplication': 'Multiplicación',
  'games.math.operations.division': 'División',
  'games.math.operations.mixed': 'Mixto',

  // Aventura Matemática - Juego
  'games.math.aventura.subtitle': '¡Encuentra el tesoro resolviendo problemas!',
  'games.math.aventura.mapAlt': 'Mapa del tesoro',
  'games.math.aventura.storyHeading': '📖 La Historia',
  'games.math.aventura.storyP1Pre': 'Eres un valiente explorador que descubrió un mapa antiguo que conduce a un tesoro legendario. Para encontrarlo, debes superar ',
  'games.math.aventura.storyP1Bold': '10 misiones matemáticas',
  'games.math.aventura.storyP1Post': ' llenas de aventuras.',
  'games.math.aventura.storyP2': 'Cada misión te acercará más al tesoro final. ¿Estás listo para la aventura? 🗺️',
  'games.math.aventura.howToPlayHeading': '🎯 Cómo Jugar',
  'games.math.aventura.step1': 'Lee la historia de cada misión',
  'games.math.aventura.step2': 'Resuelve el problema matemático',
  'games.math.aventura.step3Pre': 'Gana ',
  'games.math.aventura.step3Bold': '10 puntos',
  'games.math.aventura.step3Post': ' por cada respuesta correcta',
  'games.math.aventura.step4': 'Puedes pedir una pista (-2 puntos)',
  'games.math.aventura.step5': '¡Completa las 10 misiones para encontrar el tesoro!',
  'games.math.aventura.startButton': '🚀 Comenzar Aventura',
  'games.math.aventura.completeTitle': '¡Aventura Completada!',
  'games.math.aventura.completeSubtitle': '¡Encontraste el tesoro legendario!',
  'games.math.aventura.treasureFoundAlt': 'Tesoro encontrado',
  'games.math.aventura.treasuresFoundLabel': 'Tesoros Encontrados',
  'games.math.aventura.congratsTitle': '¡Felicidades, Explorador!',
  'games.math.aventura.congratsMessage': 'Has demostrado ser un gran matemático y aventurero. El tesoro legendario es tuyo. ¡Bien hecho!',
  'games.math.aventura.newAdventureButton': '🔄 Nueva Aventura',
  'games.math.aventura.progressLabel': 'Progreso de la Aventura',
  'games.math.aventura.treasuresLabel': 'Tesoros:',
  'games.math.aventura.missionLabel': 'Misión {{number}}',
  'games.math.aventura.solveTheProblem': 'Resuelve el Problema',
  'games.math.aventura.mathChallenge': 'Desafío Matemático',
  'games.math.aventura.operationLabel': 'Operación:',
  'games.math.aventura.hintLabel': '💡 Pista',
  'games.math.aventura.showHintButton': '💡 Mostrar Pista (-2 puntos)',

  'games.math.aventura.mission1.title': 'El Mapa del Tesoro',
  'games.math.aventura.mission1.story': '🗺️ Encontraste un mapa antiguo. Para descifrar la primera pista, necesitas resolver este problema...',
  'games.math.aventura.mission1.problem': 'El mapa muestra 3 islas. En cada isla hay 4 palmeras. ¿Cuántas palmeras hay en total?',
  'games.math.aventura.mission1.context': '3 islas × 4 palmeras',
  'games.math.aventura.mission1.hint': 'Multiplica el número de islas por las palmeras de cada una',
  'games.math.aventura.mission1.reward': '¡Descubriste la ubicación de la primera isla! 🏝️',
  'games.math.aventura.mission2.title': 'El Puente Colgante',
  'games.math.aventura.mission2.story': '🌉 Llegas a un puente colgante. Para cruzarlo con seguridad, debes calcular...',
  'games.math.aventura.mission2.problem': 'El puente mide 45 metros de largo. Ya caminaste 18 metros. ¿Cuántos metros te faltan?',
  'games.math.aventura.mission2.context': '45 metros - 18 metros',
  'games.math.aventura.mission2.hint': 'Resta lo que ya caminaste del total',
  'games.math.aventura.mission2.reward': '¡Cruzaste el puente con éxito! 🎉',
  'games.math.aventura.mission3.title': 'La Cueva Misteriosa',
  'games.math.aventura.mission3.story': '🕳️ Entras a una cueva oscura. Encuentras cofres con monedas de oro...',
  'games.math.aventura.mission3.problem': 'Hay 6 cofres. Cada cofre tiene 8 monedas de oro. ¿Cuántas monedas tienes en total?',
  'games.math.aventura.mission3.context': '6 cofres × 8 monedas',
  'games.math.aventura.mission3.hint': 'Multiplica los cofres por las monedas de cada uno',
  'games.math.aventura.mission3.reward': '¡Recogiste todas las monedas! 💰',
  'games.math.aventura.mission4.title': 'El Río Torrentoso',
  'games.math.aventura.mission4.story': '🌊 Necesitas cruzar un río. Debes repartir los suministros en las balsas...',
  'games.math.aventura.mission4.problem': 'Tienes 36 suministros y 4 balsas. ¿Cuántos suministros van en cada balsa?',
  'games.math.aventura.mission4.context': '36 suministros ÷ 4 balsas',
  'games.math.aventura.mission4.hint': 'Divide los suministros entre las balsas',
  'games.math.aventura.mission4.reward': '¡Cruzaste el río a salvo! 🚣',
  'games.math.aventura.mission5.title': 'La Montaña Sagrada',
  'games.math.aventura.mission5.story': '⛰️ Subes una montaña empinada. Necesitas calcular la altura...',
  'games.math.aventura.mission5.problem': 'Subes 125 metros, descansas y subes 87 metros más. ¿A qué altura estás?',
  'games.math.aventura.mission5.context': '125 metros + 87 metros',
  'games.math.aventura.mission5.hint': 'Suma las dos alturas',
  'games.math.aventura.mission5.reward': '¡Llegaste a la cima! 🏔️',
  'games.math.aventura.mission6.title': 'El Templo Antiguo',
  'games.math.aventura.mission6.story': '🏛️ Encuentras un templo con puertas numeradas. Para abrirlas...',
  'games.math.aventura.mission6.problem': 'La puerta tiene el código: 15 × 7. ¿Cuál es el número?',
  'games.math.aventura.mission6.context': '15 × 7',
  'games.math.aventura.mission6.hint': 'Multiplica 15 por 7',
  'games.math.aventura.mission6.reward': '¡Las puertas se abrieron! 🚪',
  'games.math.aventura.mission7.title': 'El Jardín de Gemas',
  'games.math.aventura.mission7.story': '💎 Entras a un jardín lleno de gemas preciosas...',
  'games.math.aventura.mission7.problem': 'Recolectas 8 gemas rojas, 12 azules y 15 verdes. ¿Cuántas gemas tienes?',
  'games.math.aventura.mission7.context': '8 + 12 + 15',
  'games.math.aventura.mission7.hint': 'Suma todas las gemas',
  'games.math.aventura.mission7.reward': '¡Tu bolsa está llena de gemas! 💎',
  'games.math.aventura.mission8.title': 'El Laberinto de Espejos',
  'games.math.aventura.mission8.story': '🪞 Entras a un laberinto confuso. Para encontrar la salida...',
  'games.math.aventura.mission8.problem': 'Das 24 pasos al norte, 16 al sur. ¿Cuántos pasos netos avanzaste al norte?',
  'games.math.aventura.mission8.context': '24 pasos - 16 pasos',
  'games.math.aventura.mission8.hint': 'Resta los pasos al sur de los pasos al norte',
  'games.math.aventura.mission8.reward': '¡Encontraste la salida! 🎯',
  'games.math.aventura.mission9.title': 'La Cascada Dorada',
  'games.math.aventura.mission9.story': '💧 Llegas a una cascada mágica con monedas flotantes...',
  'games.math.aventura.mission9.problem': 'Caen 144 monedas. Las repartes entre 12 amigos. ¿Cuántas recibe cada uno?',
  'games.math.aventura.mission9.context': '144 monedas ÷ 12 amigos',
  'games.math.aventura.mission9.hint': 'Divide las monedas entre los amigos',
  'games.math.aventura.mission9.reward': '¡Todos recibieron su parte justa! 🤝',
  'games.math.aventura.mission10.title': 'El Tesoro Final',
  'games.math.aventura.mission10.story': '🏆 ¡Llegaste al tesoro final! Pero está protegido por un último acertijo...',
  'games.math.aventura.mission10.problem': 'El cofre tiene 3 candados. Cada candado necesita 25 gemas. ¿Cuántas gemas necesitas?',
  'games.math.aventura.mission10.context': '3 candados × 25 gemas',
  'games.math.aventura.mission10.hint': 'Multiplica los candados por las gemas necesarias',
  'games.math.aventura.mission10.reward': '🎊 ¡ENCONTRASTE EL TESORO LEGENDARIO! 🎊',

  // Desafío Matemático Rápido - Juego
  'games.math.desafioRapido.subtitle': '¡Resuelve problemas contra el reloj!',
  'games.math.desafioRapido.selectDifficulty': 'Selecciona la Dificultad',
  'games.math.desafioRapido.operationType': 'Tipo de Operación',
  'games.math.desafioRapido.gameRulesHeading': '📋 Reglas del Juego',
  'games.math.desafioRapido.rule1Pre': 'Tienes ',
  'games.math.desafioRapido.rule1Bold': '30 segundos',
  'games.math.desafioRapido.rule1Post': ' por problema',
  'games.math.desafioRapido.rule2Pre': 'Gana ',
  'games.math.desafioRapido.rule2Bold': '10 puntos base',
  'games.math.desafioRapido.rule2Post': ' + bonos de velocidad',
  'games.math.desafioRapido.rule3Bold': 'Las rachas',
  'games.math.desafioRapido.rule3Post': ' te dan puntos extra',
  'games.math.desafioRapido.rule4': '¡Resuelve tantos como puedas!',
  'games.math.desafioRapido.startButton': '🚀 Comenzar Desafío',
  'games.math.desafioRapido.gameOverTitle': '¡Juego Terminado!',
  'games.math.desafioRapido.gameOverSubtitle': 'Estos son tus resultados',
  'games.math.desafioRapido.averagePerProblem': 'Promedio por Problema',
  'games.math.desafioRapido.problemLabel': 'Problema:',
  'games.math.desafioRapido.tipBold': 'Consejo:',
  'games.math.desafioRapido.tipText': 'Responde rápido para ganar puntos extra por tiempo',

  // Duelo de Números - Juego
  'games.math.dueloNumeros.subtitle': '¡Compite contra el tiempo en una racha épica!',
  'games.math.dueloNumeros.levelColon': 'Nivel:',
  'games.math.dueloNumeros.gameModeHeading': '🎮 Modo de Juego',
  'games.math.dueloNumeros.introP1Pre': 'En este desafío intenso, los problemas se vuelven ',
  'games.math.dueloNumeros.introP1Bold': 'más difíciles',
  'games.math.dueloNumeros.introP1Post': ' a medida que avanzas. Mantén tu racha de respuestas correctas para ganar puntos extra.',
  'games.math.dueloNumeros.introP2Pre': '¡Pero ten cuidado! Solo tienes ',
  'games.math.dueloNumeros.introP2Bold': '3 vidas',
  'games.math.dueloNumeros.introP2Post': ' y el tiempo corre. ¿Cuántos problemas puedes resolver?',
  'games.math.dueloNumeros.feature1Title': '3 Vidas',
  'games.math.dueloNumeros.feature1Desc': 'Piérdelas y se acaba el juego',
  'games.math.dueloNumeros.feature2Title': 'Tiempo Límite',
  'games.math.dueloNumeros.feature2Desc': '20 segundos por problema',
  'games.math.dueloNumeros.feature3Title': 'Sistema de Rachas',
  'games.math.dueloNumeros.feature3Desc': 'Más rachas = más puntos',
  'games.math.dueloNumeros.feature4Title': 'Dificultad Progresiva',
  'games.math.dueloNumeros.feature4Desc': 'Sube de nivel cada 5 problemas',
  'games.math.dueloNumeros.pointsSystemHeading': '💎 Sistema de Puntos',
  'games.math.dueloNumeros.pointsRule1Bold': '10 puntos base',
  'games.math.dueloNumeros.pointsRule1Post': ' por cada respuesta correcta',
  'games.math.dueloNumeros.pointsRule2Bold': 'Bono de tiempo:',
  'games.math.dueloNumeros.pointsRule2Post': ' Más rápido = más puntos',
  'games.math.dueloNumeros.pointsRule3Bold': 'Bono de nivel:',
  'games.math.dueloNumeros.pointsRule3Post': ' Nivel × 5 puntos extra',
  'games.math.dueloNumeros.pointsRule4Bold': 'Bono de racha:',
  'games.math.dueloNumeros.pointsRule4Post': ' Racha × 3 puntos extra',
  'games.math.dueloNumeros.startButton': '🚀 Comenzar Duelo',
  'games.math.dueloNumeros.duelOverTitle': '¡Duelo Terminado!',
  'games.math.dueloNumeros.duelOverSubtitle': 'Estas son tus estadísticas',
  'games.math.dueloNumeros.levelValue': 'Nivel {{level}}',
  'games.math.dueloNumeros.levelReachedLabel': 'Nivel Alcanzado',
  'games.math.dueloNumeros.achievementUnlockedTitle': '¡Logro Desbloqueado!',
  'games.math.dueloNumeros.streakMasterBold': 'Maestro de Rachas',
  'games.math.dueloNumeros.streakMasterText': ' - Lograste una racha de {{count}}',
  'games.math.dueloNumeros.levelChampionBold': 'Campeón de Nivel',
  'games.math.dueloNumeros.levelChampionText': ' - Alcanzaste el nivel {{level}}',
  'games.math.dueloNumeros.difficultyLabel': 'Dificultad',
  'games.math.dueloNumeros.incorrectLostLife': 'Incorrecto - Perdiste una vida',
  'games.math.dueloNumeros.levelUpTitle': '🎉 ¡Subiste al Nivel {{level}}! 🎉',
  'games.math.dueloNumeros.levelUpDesc': 'Los problemas ahora son más difíciles',

  // Memorama Matemático - Juego
  'games.math.memoryMatch.subtitle': 'Encuentra los pares de problemas y respuestas',
  'games.math.memoryMatch.gradeK': 'Kínder',
  'games.math.memoryMatch.grade1': '1er Grado',
  'games.math.memoryMatch.grade2': '2do Grado',
  'games.math.memoryMatch.grade3': '3er Grado',
  'games.math.memoryMatch.matchesLabel': 'Parejas',
  'games.math.memoryMatch.movesLabel': 'Movimientos',
  'games.math.memoryMatch.gradeLabel': 'Grado',
  'games.math.memoryMatch.selectGradeLevel': 'Selecciona el Nivel de Grado',
  'games.math.memoryMatch.newGameButton': '🔄 Nuevo Juego',
  'games.math.memoryMatch.congratulationsTitle': '¡Felicidades!',
  'games.math.memoryMatch.congratsMessage': '¡Encontraste todas las parejas!',
  'games.math.memoryMatch.backToGames': 'Volver a los Juegos',
  'games.math.memoryMatch.howToPlayHeading': '📖 Cómo Jugar',
  'games.math.memoryMatch.step1Title': 'Haz clic en las cartas',
  'games.math.memoryMatch.step1Desc': 'Voltea dos cartas para revelar su contenido',
  'games.math.memoryMatch.step2Title': 'Encuentra las parejas',
  'games.math.memoryMatch.step2Desc': 'Empareja los problemas matemáticos con sus respuestas',
  'games.math.memoryMatch.step3Title': 'Recuerda las posiciones',
  'games.math.memoryMatch.step3Desc': 'Usa tu memoria para encontrar las parejas más rápido',
  'games.math.memoryMatch.step4Title': 'Gana el juego',
  'games.math.memoryMatch.step4Desc': 'Empareja todas las cartas en la menor cantidad de movimientos',

  // Titulos/descripciones por pagina para <title>/<meta description> (ver SeoHead.tsx) --
  // antes todas las paginas publicas mostraban el mismo titulo/descripcion generico de la
  // portada (fijo en index.html), sin importar el contenido real de cada una.
  'seo.home.title': 'TutorAI Kids - Tutoría Inteligente con IA para Niños',
  'seo.home.description': 'Plataforma educativa con IA que ayuda a niños con sus tareas escolares. Nuestro tutor guía con preguntas para fomentar el pensamiento crítico, con seguimiento de progreso, análisis de tareas y sistema de logros.',
  'seo.planes.title': 'Planes y Precios - TutorAI Kids',
  'seo.planes.description': 'Elige el plan perfecto para tu familia: Básico, Family o Premium. Tutoría con IA, ayuda con tareas y juegos educativos para niños.',
  'seo.faq.title': 'Preguntas Frecuentes - TutorAI Kids',
  'seo.faq.description': 'Respuestas a las preguntas más comunes sobre TutorAI Kids: precios, seguridad, cómo funciona el tutor de IA, y más.',
  'seo.guiasPadres.title': 'Guías para Padres - TutorAI Kids',
  'seo.guiasPadres.description': 'Guías útiles para padres sobre cómo apoyar el aprendizaje de tu hijo, hábitos de tarea, y aprovechar al máximo TutorAI Kids.',
  'seo.privacidad.title': 'Política de Privacidad - TutorAI Kids',
  'seo.privacidad.description': 'Conoce cómo TutorAI Kids recopila, usa y protege la información de tu familia, incluyendo nuestras prácticas de privacidad infantil conformes con COPPA.',
  'seo.terminos.title': 'Términos de Servicio - TutorAI Kids',
  'seo.terminos.description': 'Los términos y condiciones para usar TutorAI Kids, incluyendo detalles de suscripción, consentimiento parental y uso aceptable.',
  'seo.accesibilidad.title': 'Declaración de Accesibilidad - TutorAI Kids',
  'seo.accesibilidad.description': 'Nuestro compromiso de hacer que TutorAI Kids sea accesible para todos los niños y familias, incluyendo soporte para tecnologías de asistencia.',
  'seo.demo.title': 'Prueba la Demo - TutorAI Kids',
  'seo.demo.description': 'Descubre cómo el tutor de IA de TutorAI Kids guía a los niños con la tarea, con una demostración interactiva en vivo.',
  'seo.about.title': 'Sobre Nosotros - TutorAI Kids',
  'seo.about.description': 'Conoce quién opera TutorAI Kids, nuestro enfoque de tutoría socrática con IA, y cómo contactar a nuestro equipo.',

  // Pagina "Sobre Nosotros" -- agrega una senal de autoridad/confianza (E-E-A-T) que el sitio
  // no tenia: antes no existia ninguna pagina publica que dijera quien opera el producto.
  'about.badge': 'Sobre Nosotros',
  'about.title': 'Sobre TutorAI Kids',
  'about.subtitle': 'Un tutor con IA que ayuda a pensar, no que da las respuestas.',
  'about.intro': 'TutorAI Kids es un producto de Neo AI Estudio, diseñado para acompañar a niños en edad escolar con un método de preguntas guiadas que fomenta el pensamiento crítico en lugar de solo entregar respuestas. La plataforma es completamente bilingüe (español e inglés) y le da a los padres visibilidad real sobre el progreso de sus hijos.',
  'about.approach.title': 'Nuestro enfoque',
  'about.approach.text': 'En vez de resolver la tarea por el niño, TutorAI Kids guía con preguntas, siguiendo un método socrático, para que el niño llegue a la respuesta por su cuenta. Los padres reciben reportes de progreso y pueden ver en qué está trabajando su hijo.',
  'about.company.title': 'Quién opera TutorAI Kids',
  'about.company.text': 'Este servicio es operado por Neo AI Estudio.',
  'about.contact.title': 'Contáctanos',
  'about.contact.text': '¿Tienes preguntas sobre el producto, la privacidad, o necesitas soporte? Escríbenos.',
  'about.contact.generalEmail': 'Soporte general',
  'about.contact.privacyEmail': 'Privacidad',
  'about.contact.legalEmail': 'Asuntos legales',
  'about.contact.whatsapp': 'WhatsApp',

  // Seccion de blog -- llena el vacio de contenido que encontro la auditoria SEO (sin blog,
  // Guias para Padres era una sola pagina estatica). Los articulos en si viven como archivos
  // .md en src/content/blog/ (ver blog.ts), no en este diccionario -- solo el "chrome" de la
  // UI (indice, boton de volver, etc.) pasa por i18n.
  'seo.blog.title': 'Blog - TutorAI Kids',
  'seo.blog.description': 'Artículos sobre tutoría con IA, ayuda con tareas, y cómo apoyar el aprendizaje de tu hijo, de parte del equipo de TutorAI Kids.',
  'blog.title': 'Blog',
  'blog.subtitle': 'Ideas prácticas sobre tutoría con IA, tareas escolares, y cómo acompañar el aprendizaje de tu hijo.',
  'blog.readMore': 'Leer más',
  'blog.backToBlog': 'Volver al blog',
  'blog.empty': 'Muy pronto publicaremos aquí.',
};
